"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SHu_const_airtable_rentalListing_fieldIds = exports.SHu_const_airtable_DailyUnitsStatusReporting_fieldIds = exports.SHu_const_airtable_UtilityAllowanceConfiguration_fieldIds = exports.SHu_const_airtable_leads_fieldIds = exports.SHu_const_airtable_contacts_fieldIds = exports.SHu_const_airtable_housingAuthorities_fieldIds = exports.SHu_const_airtable_zipcodes_fieldIds = exports.SHu_const_airtable_states_fieldIds = exports.SHu_const_airtable_neighborhoods_fieldIds = exports.SHu_const_airtable_units_fieldIds = exports.SHu_const_airtable_engGeoids_fieldIds = exports.SHu_const_airtable_engLocalities_fieldIds = exports.SHu_const_airtable_markets_fieldIds = exports.SHu_const_airtable_underwriting_fieldIds = exports.SHu_const_airtable_properties_fieldIds = exports.SHu_const_airtable_fieldsInBase_fieldIds = exports.SHu_const_airtable_tableIds = void 0;
exports.SHu_const_airtable_tableIds = {
    properties: "tblJ9n4zVNc6Zm0Lt",
    underwriting: "tblDMrzPqfsh1sfqn",
    units: "tblDKvmSDg6J9X8l3",
    markets: "tbln7RFtiEEqOn2Bc",
    neighborhoods: "tblI7BOKaHQ0mheXx",
    engGeoids: "tblmQoz4ocmqqBow3",
    engLocalities: "tbloETu4WfXyCJRow",
    fieldsInBase: "tblwi5YEir488DGeU",
    states: "tblhZyk8xVoGc1ZSj",
    zipcodes: "tblMbYqitGLVPWimy",
    housingAuthorities: "tbleXKBbNLxsUaKTb",
    contacts: "tblJ9VIN4LIzbnQxm",
    leads: "tbl9hR1VwcgoKSU6g",
    utilityAllowanceConfiguration: "tblZltBQECgVZRJZ6",
    dailyUnitsStatusReporting: "tblFyKYd8bkAeAKX4",
    rentalListing: "tblZyGQev3v1cwJE7"
};
exports.SHu_const_airtable_fieldsInBase_fieldIds = {
    "Field Id": "fldW0viujQz8Ag851",
    "Field Name": "fld7IUQx7VthDX8LX",
    "Field Type": "fldrL610Gu7hgY7mZ",
    "Table Name": "fldxLgEB3jgot69fP",
    "Table Id": "fldPX7fFkAoBwpz9b",
    "Is Primary Field?": "fldJ19H4OrynSgBxR",
    "Field Description": "fldhmkiqUAOIZRIdZ",
    "Field Options": "fldvH1eMxZFETMEHi",
    "Compute Status": "fldJQu5pf2Ag29Zt5",
    "Computed Using": "fldudQYrDK9gOSTJb",
    "Used to Compute": "fldUTKWz25TAacOVN",
    "KPIs 2": "fldg2Uro3ATb3uFGw",
    KPIs: "fldbRg5SwsEegrEYq",
    Automations: "fldMMDqt6HhsCslIn",
    "Automations 2": "fld5DkzbHIbXiZ5lp",
};
exports.SHu_const_airtable_properties_fieldIds = {
    Address: "fldXAwZFBOG4d9Smb",
    Coordinates: "fld7FOm0QimAoQEHn",
    "Transaction Status": "flddp5AMyNFcBIlz9",
    "Lead Status": "fldrPJxsUrHqXv5yz",
    "Engineer|Geoids": "fldhsJDuJEjXJi9lN",
    Market: "fldTMqbqh97R17qr1",
    Neighborhood: "fld4dCnGb2NQchXJM",
    HousingAuthority: "fldYE4uL7RMPazujk",
    Zipcode: "fldRYwTUt0VOPngYU",
    State: "fldgc6kk1q8AUvUjP",
    "Square Feet": "fldAgZAZQTSArKUzZ",
    "Year Built": "fld4qukJCPVmt2xzZ",
    "Listing / Asking Price (Submission)": "fld3H7ZG0M5X0PC02",
    "Originators Renovation Amount (on Submission)": "fldA9nD9uVuP0tkqO",
    "Submitted By": "fldChW2dqf0VGltv8",
    "Listing Agent": "fldk4pbV72aeODb1o",
    "Place ID": "fldYQRwdsequIM8BJ",
    "Lease Status (from Leases)": "fld3VJGGCI6gCgicr",
    Tract: "fldlP36ECdAb8QVAs",
    "Default PM Fees per month (from Market)": "fldt84qKd7HnGw45A",
    "Default PM Onboarding Fee per Unit (from Market)": "fld7EVjRKLS5A34Bu",
    "Default Minimum Reserve Amount per Unit (from Market)": "fldiJDTv1y1r4F9UQ",
    "Default Property Manager (from Market)": "fldYX2Cdr3FrXR7Xx",
    "PM Fees Per Month (from Property Managers)": "fldRCFXtRyXSCxzNo",
    "Minimum Reserve Amount Per Unit (from Property Managers)": "fldctiuPIB6nVNBjR",
    "PM Onboarding Fee per Unit (from Property Managers)": "fldEsn8eLIlKnDhud",
    "UW Minimum PM Reserve Amount": "fldJQi7l7sjJvxd11",
    "UW PM Onboarding Costs": "fldWVddTNj13M3NMo",
    "UW PM Fee Percentage": "fldFUMo8flgWwqvaY",
    "Units Monthly Property management Fee": "fld7mKupY1k39mbcm",
    "Unit PM Onboarding": "fldwiMhFQfgsuh4Vt",
    "Additional Underwritten Ownership Reserves": "fld12ZMOVNWwuOp6k",
    "Total Underwritten Ownership Reserves": "fldYWUTEkX2Dsoyaw",
    "Name (from Property Manager) (from Market) 2": "fldf5OVCAFLfwwnW6",
    "Comparable Market Rent Monthly NOI": "fld20ZJ3stNBUWfLK",
    "Comparable Market Rent Annual NOI": "fldsAQ5CJ73LbTnKc",
    "Actual Initial Renovation cost total": "fldt0FikguyZK5c47",
    "Property Taxes": "fldVM13jbPkHIiIi7",
    "External Inspections": "fld8LoZqlhlbItkfL",
    "Current Lease Monthly Property Management Fee (from Units)": "fld9tvf2MURMk6AxV",
    "Current Lease Monthly Vacancy (from Units)": "fldgYl0WfWlQdj8dM",
    "Current Lease Monthly Asset Management Fee (from Units)": "fldYa5LPZmhhhu9JB",
    "Adjusted Simply Utility Cost (from Units)": "fld9iw8c68Hl3RMPL",
    "AIO Map Button": "fldcaOVr5aoVMr43v",
    "Renovation Overage Percent (from Market)": "fldmEQVfzcGufT2Fe",
    "Status (from Rental Listings) (from Units)": "fldKuZTDeQHH7C5na",
    "Lease Subsidization  (from Current Lease) (from Units)": "fldBI1NtGcVufVChJ",
    "Archived Leases (from Units)": "fldjP87fVp5wA3NYD",
    "Utility Setup Phone Number (from Owner Entity)": "fldlRakfqBuFYJ85u",
    "Seller Due Diligence Request (from Market)": "fldhkauIryWaDkqEY",
    "Inspection Photos (from Inspections)": "fldndNICct8X7gghX",
    "Unit #4 HCV Bedrooms (from Inspections)": "fldFuktrJ1dGIJAH4",
    "Unit #3 Bathrooms (from Inspections)": "fldXPehpJoQCCt9BJ",
    "Unit #3 Bathrooms - Actual": "fldUS4WgIqnzuVtvW",
    "Garage Spaces": "fldBJ8LYYC6vUZWmX",
    "Late Fee % (from Property Managers)": "fldWdFeAhsKUS3CNu",
    "Engineering | Renovation Budget (from Underwriting)": "fldUUvktUF3qM3yow",
    "Originators Renovation Estimate (from Leads)": "fldmf3DfEtXdvRHMX",
    "Deed of Transfer (from Transactions)": "fld2Kn3stOxkBVtoG",
    Appraisals: "fldBOjyVpBZ2bDvAg",
    "Invoice Document (from Reno Invoices)": "fldRSTLpoMWyjcADr",
    "Field 414": "flddhfCBFeSXoStRO",
    Disposition: "fldP1CQOAA1uaMAj0",
    "Unit 4 Beds (listing)": "fldJA59c5SeYz3QdC",
    "Final HUD Amount": "fldg0x05W9MSfknRp",
    "Full Name (from Owner Entity)": "fldlQfymcehi91f0b",
    "6 bed (from Tract)": "fldprS5BWZyWn7KA4",
    "Estimated Annual NOI": "fldWxiBj8rqTYgVHd",
    "Pet Deposit Amount (from Property Managers)": "fldEwgkqe8qqHlzSP",
    "Implied Monthly NOI": "fldDWD6irsnj9EhCN",
    "Acquisition Inspection status": "fldkXqPZKReG6vk6K",
    "Acquisition Inspections: Confirm # of Bed (from Inspections)": "fldtmxXR8QUtJUx8j",
    "Unit #1 Bathrooms (from Inspections)": "fldnMYTVwVPjF562Z",
    "Title Diligence Checklist (from Templates and Documents) (from Market)": "fldmSNYyvnOHorEju",
    "House Type (from Utility Configuration) (from Units)": "fld8CgbScedTm43gB",
    "Inspection Status (from Inspections)": "fldfZ6v0RNlj3SYjM",
    "Initial Estimated Renovation Time": "fldKyuReKG4R7jMPo",
    "2 Bedrooms Utilities Allowance (APT) (from Housing Authority)": "fldVPobz69bhGxhlQ",
    "Property Classification": "fldAf78hRlQKRn8w4",
    "Total Bathrooms": "fldMskCVev6qrouXa",
    "Total Bedrooms": "fldvlIPbiNx2e1Qr8",
    "PM Fee Override": "fldazPwYV07wWaOUX",
    "Grace period (Late Payments) (from Property Managers)": "fldV5eaixuOHnHhYT",
    "Zillow Link": "fldMF5Zr2uPurNmTq",
    "Days since Contracted": "fldf1VoPLyP2kgJ0P",
    "Monthly Gross Rent": "fldVCpSyDyzdwYxwb",
    "Implied Annual NOI": "fldhqiDhOLCMo43c4",
    "Implied Cap Rate": "fldKAHh07RH6jc2XB",
    "Adjusted Simply Utility Cost": "fldwYvrvD1aSHGQnV",
    "Total Reserve Amount": "fldNxn5ZpF5hn9lpc",
    "Threshold NOI Cap Rate (from Market)": "fldzk7ewlBfkWoxUk",
    "Unit #1 Bedrooms - Actual": "fldWipBPShBXxFw4X",
    "5 Bedrooms Utilities Allowance (APT) (from Housing Authority)": "fldVAayEm2aLXNBXc",
    "5 bed (from Tract)": "fldPbNWWtTbyegZc2",
    "Monthly Gross Rent (from Units)": "fldwuR89AAkV8M1Yr",
    "Estimated Annual Gross Rent": "fldKgCrz9aWbKNvRu",
    "HCV Payment Standards (from Units)": "fldeHqWvV5fstTt4b",
    "Market copy": "fldmqjiQWbeTQljED",
    "Unit #3 Bedrooms - Actual": "fld94n19hVmbDhEoX",
    "Title Checklist": "fldcOaA7txIuqOAHA",
    "RentoMeter Market Rent (from Units)": "fldbVpjwoP1NQvHkT",
    "Estimated HCV Utility Allowances (from Units)": "fldAqyIb2xqtJ0hrf",
    "5 Bedrooms (from Zip Code)": "fldrX0gNnSlTGmHAd",
    "Effective Rate(Tax) (from Borough / Neighborhood)": "fldtjfMnwP9LRTrzB",
    "Unit #4 Bedrooms - Actual": "fldgTEwNCijtRkJUd",
    "Transaction Status (from Transactions)": "flddp5AMyNFcBIlz9",
    "4 bed (from Tract)": "fldrrMqEgDbwQYG6q",
    "ACS NOI (Annual) (from Underwriting)": "fldizflVNv22zBEZX",
    "Current Loans": "fld8rDlg3yxNlQQHn",
    "Monthly Vacancy (from Units)": "fldaRI35BhFhXMqfz",
    "6 Bedrooms (from Zip Code)": "fldyMkZm3MHIuhhMQ",
    "Engineer|States copy": "fldUjs01VKqZPtfel",
    "Actual ARV vs UW ARV": "fldyWLYBgAoprxYn6",
    "Core Closing Cost (from Market)": "fldx4QgEfzJeYQ2F9",
    "Override Core Closing Costs (from Underwriting)": "fld1ArqtgGrzakT9G",
    "Estimated Closing Date": "fldfGshXvlnNNJvSQ",
    "Name (from Market)": "fld7I7MmKkirxFz51",
    "Estimated Annual Repairs and Maintenance": "fld5FqHLwUYwarDs9",
    "Has Garage": "fldnpY8LZgNaFS8Tr",
    "Total RentoMeter Market Rent (from Units)": "fldYgAJu0q7vFO3XB",
    "Bedroom Increase Details": "fldVXy8lgZIjG1lrH",
    "Underwriters ARV (from Underwriting)": "fldKhXpnXoNIAWNcS",
    "Unit Supplied Microwave (from Units)": "fldyGNTZPbqI1wN1T",
    "First Lease Date (Under SH Ownership) (from Units)": "fldE4UBeVXv5O0M10",
    "Comparable Market Rent Cap Rate": "fld8VlD4WRJmH9R1f",
    "Initial SOW (from Inspections)": "fld7WA5KAlQBZMyH4",
    "Unit #1 Bathrooms - Actual": "fld2qaN0Yt6La3oxu",
    "1 Bedrooms Utilities Allowance (APT) (from Housing Authority)": "fldTJiEWushUBvsxD",
    "ACS Gross Rent Received (from Underwriting)": "fldfiCNYvuTuWuZ6R",
    "Remaining Loan Amount": "fldMwaeXE97sh2DTt",
    "Unit Supplied Refrigerator (from Units)": "flduRHPaE1lrhiYPd",
    "Satellite Preview": "fld4FOGogNF74876T",
    "December Renovations Expenses": "fldL3NESVYySkYu0W",
    "Proforma All In Cost": "fldi0SD6bfbdhZPbZ",
    "Default Buyer Entity (from Market)": "fldwLLD0YpVkk1iLF",
    "Unit Supplied Range (from Units)": "fld1sQnaYLPBRuYxH",
    "November Renovations Expenses": "fldZh477i9GDnoVHi",
    "County (from Borough / Neighborhood)": "fldcFfV3pUReKzx6i",
    "6 Bedroom Utilities Allowance (from Housing Authority)": "fldAOMo8ahFczAMHy",
    "Replacement Cost (from Underwriting) 2": "fldvBIvEnl151E53L",
    "Monthly Asset Management Fee (from Units)": "fldr7O1XDXS2WYiq2",
    "Renovation Start Date (from Renovations)": "fldcodZgYab5W0IrD",
    "Pet Fee (from Property Managers)": "fldkpfbYszhqsV7DT",
    "October Expenses": "fldK5vjfaWsqAr13i",
    "Total Renovations Expenses": "fldRZX34ujp8iZNiC",
    "PM Email Address (from Contact) (from Property Manager)": "flduVZshGKxtYRYH6",
    "Calculated Insurance Premiums (from Underwriting)": "fldnXNRXoCQbdVYpx",
    "Mobilization Funding (from Market)": "fldxDF73boHhBdvME",
    "Monthly Property Management Fee (from Units)": "fldtvCW6hl2F9w89N",
    Reno: "fld1GXBgbb3T9i7Nx",
    "Unit #2 Bathrooms - Actual": "fld1dZYs3ahq07Jwn",
    "Mailing Address (from Owner Entity)": "fldY362Q79kBB9F2W",
    "Has Air Conditioning (from Units)": "fld4F4T0Avznw19YX",
    "4 Bedrooms (from Zip Code)": "fldNa5Swwkrv0E0ZF",
    "Estimated Monthly Tax Cost": "fldnDwKrgzSQ289vH",
    "Time on Market Prior to Leasing  (from Units)": "fldrh4Ib2SesqhFRN",
    "Market Rent Monthly Asset Management Fee (from Units)": "fldm06yqRQOPSJx91",
    "Unit #4 Bathrooms - Actual": "fldbYpQ27fJ0hYHtm",
    "4 Bedrooms Utilities Allowance (APT) (from Housing Authority)": "fldPyJbQaXrK0w3XX",
    "Estimated Monthly NOI": "fldVqkBChVTxl5Qx9",
    Source: "fldw2mzDaeFliZZw1",
    "Asset Manager (from Market)": "fldnX96myD3w8cME2",
    "R&M Reserve Assumption (from Market)": "fldWbQanSqaMsw1wQ",
    "Actual Renovation Completion Date (from Renovations)": "fldbsAwLcKsHbMw30",
    "Estimated Annual Property Management Fee": "fldMAc3tnebCAOx20",
    "Has HOA": "fld4JFckXdxTNauvU",
    "Renovation Status (from Renovations)": "fldzTELklbWaRqWut",
    "Inspection: Confirm # of Units (from Inspections)": "fldb7vEsxpbrbpeVh",
    "Heating Source Type (from Units)": "fld0vrZoxIIvEwfH2",
    "EIN (from Owner Entity)": "fldoU7RhZCfgmING8",
    "0 Bedrooms Utilities Allowance (APT) (from Housing Authority)": "fldPYDXIA6YXg4FN7",
    "3 bed (from Tract)": "fld3x01UY2XToKFLo",
    "Lender (from Loan)": "fldIswFa1lD1y98V0",
    "Estimated Monthly Gross Rent (from Units)": "fldlFVXzJqgEAGNhH",
    "Cooking Fuel Type (from Units)": "fldLC9688E7t67Eqq",
    "Generic Replacement Cost / Sqft. (from Market)": "fld9eNBRvLvbaqbY7",
    "Estimated Monthly Property Management Fee": "fldjmhlyUFcLWqGkq",
    "Estimated Annual Asset Management Fee": "fld3Xy6EZ2C2e0dNM",
    "Has Gate": "fldt7wWS9EPUV8gR0",
    "Violation of Pet Policy Fee (from Property Managers)": "fldP8Y2ARVbskAbcN",
    "Market Rent Monthly Vacancy (from Units)": "fldRm4KiWNmut2qnj",
    "Title Company (from Transactions)": "fldCTSwQPYRX11Bb8",
    "Unit #3 HCV Bedrooms (from Inspections)": "fldb7kMDB7gWKSXVv",
    "7 bed (from Tract)": "fldxPlh2ubf5dryLq",
    "Lease Documents (from Units)": "fldPJJr4v8NauUFiF",
    "Sewage Type": "fldrUDt97ONpz7tYg",
    "Asset Management Fee To Simply (from Owner Entity)": "fldWMDKAdc1rvGJdO",
    "Ready for Market Date (from Units)": "fldRxOwzaHafGDC3U",
    "Market Rent Monthly Property Management Fee (from Units)": "fld3naOGf2UAiCjMp",
    "HCV Rent Reference (from Housing Authority)": "fldDqupus4h6kSThC",
    "Unit #2 HCV Bedrooms (from Inspections)": "fldHNVHpRhAs2AHaC",
    "Registered Address (from Owner Entity)": "fldc4Hb9r0ax2oOvO",
    "Estimated Annual Vacancy": "fldmZLCKkrQ7wGE4H",
    "SH Renovation Fees (from Renovations)": "fldKRSjdA0mTBXqVC",
    "Unit 1 Baths (listing)": "fldKBe8DMvS2HEVhi",
    "Estimated Gross HUD Amount": "fld33jhoeml4Zw6HA",
    "Transaction Created Date (from Transactions)": "fldjQlA3tZHTaY1NC",
    "Time to Closing": "fldNTajyHXoHR9A3V",
    "Time to Renovation Start": "fldvtdskG4O4jYwNo",
    "Renovation Start to Prepare for Market": "fldOI9dtR4vQWxVbd",
    "Renovation Time to Date": "fldKtEgBYXIO2iUqE",
    "Current Estimate of Renovation Completion Date (from Renovations)": "fldsJBuXRMiYjJrtq",
    "Current Estimated Renovation Time": "fldZjXnsv7LKdM6wr",
    "Name (from Property Manager) (from Market)": "fldWdWhhMdulX7Cx7",
    Created: "fld2l9jHDfO1v04Xx",
    "Actual Uplift vs Actual All In": "fldRE1GS4SnAiHOTX",
    "Unit 2 Baths (listing)": "fldjJkg0X9KTKZbrU",
    "2 bed (from Tract)": "fldywiHK8Lt6ScPpF",
    "Actual All in Cost to Date": "fldPx3UXtkDK1QpB4",
    "Threshold of ARV Uplift (from Market)": "fldbKRlkZN91CSRUV",
    "Estimated Monthly Asset Management Fee": "fldaY1m5FhP2jkszD",
    "Estimated Monthly Vacancy": "fldJQZnMcKE8t5FNr",
    "Estimated Monthly Repairs and Maintenance": "fldhzvuKZD05duMug",
    "Estimated Annual Insurance Costs": "fldELGc65GZVXzOkx",
    "Estimated Annual Tax Cost": "flduJDnaLCUo2XW9i",
    "Utility Configuration (from Units)": "fld24O6FVmsto0MMl",
    "Property Classification (from Property) (from Units)": "flda7HAWkXKu4jDQJ",
    "Water Heater Type (from Units)": "fldLIJ8UTI0VPuE7A",
    "Estimated Monthly HCV Utility Deduction (from Units)": "fldgUDhVfWY0FAarq",
    "Estimated Monthly HCV Rent (from Units)": "fldAx77Yvtuxg3Id9",
    "Lease End Date (from Units)": "fldipQX3rajA55h9z",
    "Lease Start Date (from Units)": "fldYYqMso1KjxeTYF",
    "Operating Status (from Units)": "fldRJO1gAQs3k9Bne",
    "Current Estimate of Renovation Completion Date": "fldPZ3BJjqWiD3O0x",
    "Stabilization Date": "fldRAofdVg2VhW3Ts",
    "Water Type": "fldAAGhor57smu4wF",
    "Actual Closing Costs (from Transactions)": "fldjKWIBjSyabMSOl",
    "Contacts (from Housing Authority)": "fldBpoU3hYW43jDxw",
    "Property Managers": "flddi6imuivCF2Fzl",
    "Daily Late Fee  (from Property Managers)": "fldRudUB7IPPnLjC3",
    "Late Fee Min (from Property Managers)": "fldApUirNteIH0qrT",
    "ACS Status": "fldI1JzjuGdz0BBGp",
    "Monthly Insurance Premium": "fldMIlWrzJtEDeqc6",
    "Date Closed": "fldgrMQE6tBDXuC7q",
    "Actual Renovation Cost to Date": "fldlcWu3VGndoSH1y",
    "Estimated Core Closing Costs": "fld7XFmhS4RLjvnUV",
    "Title Insurance Buyer Apportionment": "fldcyCLykKxuIws73",
    "Title Insurance (from Market)": "fldefBLtx6lpUKVsL",
    "Transfer Tax Buyer Apportionment": "fldvgv50dtIEi8X4L",
    "Transfer Taxes": "fldEgbTrZ8GFdtYds",
    "Unit 2 Beds (listing)": "fldq7NZ7w534QtZbl",
    "Unit 3 Beds (listing)": "fldkKRPNZYyuRd6CT",
    "Transfer Tax": "fldCkUCebaDLL4Hjl",
    "Title Insurance": "fldjX2eCyRaHYHKo4",
    "Simply Acquisition Fee": "fldVy0VCHgPjxuoAy",
    "Third Party Assignment Fee": "fldaqbnppPNfgkb3d",
    "Contract Price": "fldT5FH8lLzWeLwYk",
    "Payment Standard (from Housing Authority)": "fld2q6sGA8KWCvoU6",
    "Tax Rate (from Borough / Neighborhood)": "fld9wJgTV5IE2iTeb",
    "Total PM Onboarding": "fld6G8pstY6NwrCLS",
    "Unit 3 Baths (listing)": "fldTtk26rIeqUCO5z",
    "Unit 4 Baths (listing)": "fldTFGBa0RfRP1jYH",
    "Assumed Loan Rate Percentage (from Market)": "fld1HNP6TOy9XvxfP",
    "Assumed LTV Percentage (from Market)": "fld5bH8IFIFeYt92m",
    "Vacancy Assumption (from Owner Entity)": "fldHj84kiz9gcJO7x",
    "Required Startup Reserves (from Owner Entity)": "fldokdOtPcoRqO732",
    "Estimated Total Cost to Owner Entity (from Inspections)": "fldSZEW3OUluO1LZT",
    "Replacement Cost (from Underwriting)": "fld8ppXqDcY1Cz3ow",
    "1 bed (from Tract)": "fldwmbaXYhI51f3qA",
    "Efficiency  (from Tract)": "fldq9wi7eJtXDBC2N",
    "Google Drive Public Photos Folder Link": "fldhX2FCmFI5BZ1HR",
    "Google Drive Public Docs Folder Link": "fld8kZnqeApv0e5rZ",
    "Annual Tax Override ": "fldI3rQMYIKUu0nc6",
    "Property Address (one line)": "fld7eBpZMgtkVAs9S",
    "Created By": "fldMw4FOsYlInakxS",
    "Simply Reference": "fldoPNZOFobqY0vmn",
    "Borough / Neighborhood": "fld4dCnGb2NQchXJM",
    "Zip Code": "fldRYwTUt0VOPngYU",
    "Current Appraisal ARV": "fldK78is0sv3GU3mP",
    "Property Created Time": "fldYrUPQuIxyIzSmo",
    "Current Appraisal": "fldvkKlAdRYk5bkW3",
    "Insurance Policy": "fldc0EVkz0sSfedI6",
    "Insurance Company": "fldDEWnIVdh4PFpmR",
    "Current Appraisal Date": "fldLDvXmcqAsSnpLl",
    Units: "fldw4nZiLBoHQxRZo",
    Leads: "fldVZw3eUWspJ1a5H",
    Inspections: "fldKJXKXBRIdLHG8j",
    Underwriting: "fld1T7mgNzgopwfjh",
    Renovations: "fldMCNALmtu9h4QbM",
    "Reno Invoices": "fldYC9lQ59OGbGYX7",
    Transactions: "fldw4DWZebYm5MFXn",
    "Street Address": "fldIFawBM96BRWeMM",
    "Property Identifier": "fldgg8tBZuxM0NZX8",
    "Property Policy Number": "fldrWt40s37PRfoT7",
    "Old Appraisals": "fldrnlyijgZpZ6M1v",
    "Applied Loans": "fldmxJMHFDGAVnvom",
    "Loan Proceeds": "fldGwZXUOIMyh1gkh",
    "Owner Entity": "fldFDri1vedQMzJOJ",
    "Photos Drive Link": "fldPdIGHgGuHHeMMZ",
    "Unit 1 Beds (listing)": "fld4jxx2FkYgXmno8",
    "Number of Units (Calculated)": "fldDC3vHlthFyOWZf",
    "Number of Units (listing)": "fldfN1TkR5VBZawbO",
    "One Line Address": "fldXAwZFBOG4d9Smb",
    "Zip Code (from Zip Code)": "fldfUZa19DHJypwYq",
    "3 Bedrooms Utilities Allowance (APT) (from Housing Authority)": "fldwVCIdf3SMQCO9G",
    "Google Drive Main Folder Link": "fldhnVQzm8YokLZeg",
    "Streetview Preview": "fldMwoBn57WNNds2K",
    "Payment Location  (from Property Managers)": "fldVxzNpfRFiQoOu6",
    "Suggested Bedroom Increase": "flda212wTkRTfzYHw",
    "Unit #2 Bedrooms - Actual": "fldFbfjH3lMfAm1dt",
    "Document (from Templates and Documents) (from Market)": "fldoDVOuSJoyIfTgJ",
    "Streetview Map URL": "fld6AurCtGcyJfrYE",
    "Borrower (from Loan)": "fld0qEIB732ZMgv23",
    ARV: "fldjlkaiePxJBNvoG",
    "Has Pool": "fldqjYu20QmQ7jMBb",
    "Email Address (from Contacts) (from Housing Authority)": "fldxtGMdSdYAi5YN2",
    "Interest Rate (from Loan)": "fldzXrIG7yyGbcKYq",
    "Expected Monthly Gross Rent (from Units)": "fldzWh0MhG9UWsN8z",
    "Estimated Monthly Insurance Costs": "fldJJVgmlv0CJ1pTd",
    "Gate Code": "fld26wu0fcbjnHc8j",
    "Zillow Button": "fld6ocJgIsmTLWJdY",
    "HOA Entity": "fldag4HzotWayy34B",
    "Insurance Policy Start Date": "fld86PX1qBD0JwoDO",
    "House Type": "fldp8yWmvqqnYmkSv",
    "Unit #1 HCV Bedrooms (from Inspections)": "fld1FHq0tN7z6T1tI",
    "Unit #2 Bathrooms (from Inspections)": "fldAg0creOigAyE1I",
    "Unit #4 Bathrooms (from Inspections)": "fldflRN5d1h3NzZFM",
    "Status (from Rental Listings) (from Units) 2": "fldwGuYSYGwMumnc6",
    "Google Map Link Button": "fldlgcbDHlxOHrcN6",
    "Name (from County) (from Borough / Neighborhood)": "fldIyxHMUmzlFzAbB",
    Walkthroughs: "fldwVWEzIy5dTQhuF",
    "Property Status": "fldZpggShO3j4ZS31",
    "ARV (Corelogic)": "flde80LUtwZCOm6PH",
    "Originators Renovation Amount (on Submission) ": "fldA9nD9uVuP0tkqO",
    "ARV Uplift (from Underwriting)": "fldnEXKoiDhAGFJBT",
    "PM Fees Percentage": "fldkM4i9DwicxxDtw",
    "Acquisition HUD Statement (from Transactions)": "fldIwjunIcUXFvKej",
    "Estimated Monthly Gross Rent": "fldVHSAsAPLL5GROW",
    "Lease Type (from Units)": "fldvLj4f21IMMWgHe",
    "Inherited Tenant (from Units)": "fldUeND2WEczApptz",
    "Current Tenant (from Units)": "fldIIckvFTsyHHjYS",
    "Occupancy (from Units)": "fldJHNoBEAjQYb0Qk",
    "Bathrooms (from Units) 2": "fldvri5JMetC2K5M4",
    "Bedrooms (from Units)": "fldYzHn9M7BUWisy0",
    "Current Lease (from Units)": "fldRb3jTlKOGlj50D",
    "Estimated Cap Rate": "fldtnNiJsyvyLZIA4",
    "Originators ARV": "fldNrODaUe48V09k2",
    "Total Estimated Monthly HCV Rent": "fldYXuESHk3BoAxlI",
    "Total Estimated Monthly HCV Utility Deduction": "fldHpfIgZTOttU34n",
    "Record ID": "fldpPVep2KBOiTLgH",
    "3 Bedrooms (from Zip Code)": "fldpxX0l9H5HkAKIR",
    "2 Bedrooms (from Zip Code)": "fldwYUtocuUSQieof",
    "1 Bedroom (from Zip Code)": "fldYd7XTFecQ12KLa",
    "0 Bedrooms (from Zip Code)": "fldWZQvxbSmiTzjqk",
    "Housing Authority": "fldYE4uL7RMPazujk",
    "5 Bedroom Utilities Allowance (from Housing Authority)": "fldv6CiTF8ywBG1KV",
    "4 Bedroom Utilities Allowance (from Housing Authority)": "fldWh2mFuWHAMiPjb",
    "3 Bedroom Utilities Allowance (from Housing Authority)": "fldXNg6xDYX7XS6eM",
    "2 Bedroom Utilities Allowance (from Housing Authority)": "fldeGELPbsv390tIg",
    "1 Bedroom Utilities Allowance (from Housing Authority)": "fldV0dceZiIxZnfBC",
    "0 Bedroom Utilities Allowance (from Housing Authority)": "fldHbW86w1Pvrzrna",
    "Property Tax": "fldQmUCbUnIeny5Fx",
    Insurance: "fldQ3OBoNuTPinTZS",
    "Repairs and Maintenance": "fldz2xfxjNQndSPaB",
    Vacancy: "fldFgtJqZkY0vjakk",
    "Asset Management": "fldN74WZeSbl5TJD1",
    "U/W Insurance": "fldJPMAamnxdCCznM",
    "UW Cap Rate": "fldK6gctS4yqa45xb",
    "UW All In Cost": "fldO8Hbq0SM6XbuZj",
    "Estimated Total Renovation Cost (Inspection)": "fldYXybgFbmTfqoHY",
    "Estimated Acquisition Costs": "fldAAJUUg6RynzcNi",
    "Housing Authority Name": "fldF2jyu99spHj7lp",
    "Name (from Borough / Neighborhood)": "fldJ1A1xklRiqp0Rv",
    "Borough/ Neighborhood Name": "fldwK8wh5dMBgpBDp",
    "HCV Rent Reference (from Housing Authority) 2": "fldiWChUXxzpW8QHE",
    "Reference Name (from Housing Authority)": "fldUEMHkV3v0xZVmn",
    "Name (from Housing Authority)": "flddqMUSKdci0BEe4",
    "Deed of Transfer (from Diligence)": "fldKWR8aA6YNK6Ep8",
    "Title Insurance (from Diligence)": "fldrJfI3OfZF96qv7",
    "Date Completed (from Inspections)": "fld4qE2fk0ZkIrcSi",
    "Notes (from Inspections)": "fldUptoK1n5BhKFdt",
    "6 Bedrooms Utilities Allowance (APT) (from Housing Authority)": "fldBvwqIX8LH5dxmK",
    "Remaining SH Profit (from Renovations)": "fld2pFLjiw3kLMurl",
    "ACS Renovation Amount (from Underwriting)": "fld441YPiTTVVsOQO",
    "One Pager (from Underwriting)": "fldFIIQnxj0XBP6zg",
    "Area is Acceptable": "fldpK1RyV2kkMefGz",
    "Rejection Reason": "fldKcJqCOmrNMfrdo",
    "has Basement": "fldS7c23MdVcXkzvq",
    "has Common Space": "fldvp24lWW1GgNBIN",
    "Roof Type": "fldkkpc36S7OKW3Dc",
    "has Off Street Parking": "fldJL4bvnnTqrJInQ",
    "Estimated End of Roof Life": "fldhJSap3oMIvVun1",
    "has exterior stairs": "fldLjMFmBU4pe1EQq",
    "has deck": "fld8hJhyOYc59qbn4",
    "has patio": "fldWBRL6855fP4jvN",
    "has sidewalk": "fldCjMSX42pUm44ki",
    "has driveway": "fldmOQzIDM7C4nX2Q",
    "has yard": "fldkJjG2T1FIjsJfN",
    "siding type": "fld3XwAfMEGzdirlY",
    "has Porch": "fldlgIBvynqYZFN4B",
    "Unit Entry Type": "fldwXLf14u4QsqsLM",
    "has Laundry": "fldbQ4fIjMf8rGrfp",
    "has Attic": "fldMASZuIQkcnRNcW",
    Stories: "fldpHJaPbGPEs9QYy",
    "has Basement Windows": "fldLjD563979gjYph",
    "has Livable Attic Space": "fldrSHuy9OsPbn6wY",
    "Off street parking spaces (garage excluded)": "fld4EZ2cQL6hqo02g",
    "Time on Market Prior to Leasing  (from Units) 2": "fldC1hFOHBrVqXZJa",
    "Time Since Ready to Market (from Units)": "fldzHqaVxmyyg0T6r",
    "Project Manager (from Market)": "fldOUkjzyK3HYdqsA",
    "Internal General Contractor (from Market)": "fldZwEuBsfvUWesqb",
    "Leasing Notification Contacts (from Property Managers)": "fldNFutcCLT7vD8pw",
    "Purchase Notification Email (from Property Managers)": "fldZJTaRR3kKBx0d5",
    "Transaction Status (from Transactions) 2": "fld3ZZBPSGcRnenU5",
    "Record ID (from Property Managers)": "fldFQiY6f7Acz5FKz",
    "Name (from Property Managers)": "fldaX2W2h5jMiwNm0",
    "Leasing Status (from Units)": "fldC25TDn5xG5hfyz",
    "Move in Fee (from Property Managers)": "fldd2tYD5RR84Umgu",
    "Lease Modification Fee (from Property Managers)": "fldVWL5dQDeywYRIU",
    "Transaction Contract Date (from Transactions)": "fldghjZSyZE4Dyhap",
    "SH Commission (from Transactions)": "fldoy7kWTM1BVSz6y",
    "SH GC Profit (from Reno Invoices)": "fldnhf953mE3Ns24B",
    "Estimated Renovation Time (from Inspections)": "fldtNeBIWgtwCKpSC",
    "Buyer Entity at Acquisition (from Transactions)": "fld0z8Qiy3azeuZuP",
    "Time to Contracting": "fldOMbAHSyBz3DRxn",
    "Acquisition Capital Calls": "fldgqFDgXB9lZowuJ",
    "Renovation Capital Calls": "fldcPK52HUbdkOTFi",
    "Google Map Link": "fldXEJNz0aPk5uZIb",
    "Current Lease Monthly Property Management Cost": "fldJXdsnoXasryQLN",
    "Current Lease Monthly Asset Management Cost": "fldtv6pjnfl5r15dB",
    "Current Lease Monthly Vacancy Amount": "fldIutjAzoblOVDrM",
    APNs: "fldfrBlrFKlqmEMNS",
    "MLS ID": "fldqTZ8xNAfIOW1PW",
};
exports.SHu_const_airtable_underwriting_fieldIds = {
    PurchasePrice: "fldjaZYRsfpDgQe1i",
    CapRate: "fld70JolXvZudbkii",
    TargetCapRate: "fldGIkHweYXw2o1VX",
    TargetArvUplift: "fldu4pFGDMLuC0R4R",
    ARV: "fld7UWdTbVdc8uYtL",
    EngMaxOfferLog: "fldBc6VoDkAFaPhjh",
    EngMaxOffer: "fld58PjZn3u0LxbH9",
    MaxOffer: "fldJkuGNJhAPpNMd3",
    NoiCapRate: "fld70JolXvZudbkii",
    ArvUplift: "flduhb0D8Lw2xSZa4",
    AskingListingPrice: "fld2LVY8XVsm0Sjfp",
    Address: "fldJoA2ZlGSR0lxsm",
    "Final HUD Amount": "fldfjSQhsU6djnu8q",
    "Residual Equity": "fldHuO0PGET2gVL2c",
    "One Pager": "flddnwxUm8DhyLAjq",
    CMA: "fldI7TxKJNxmAqflL",
    Lead: "fldE5NaRCUfV8qp0E",
    "Current Lease Information Document ": "fldGYSVq1KYuKBMGX",
    "Neighborhood Review": "fldFMg9QxYoRUzdDg",
    "Appraisal ARV": "fldJCzIfUv5rq1Z5Y",
    "Rough Renovation Costs (from Lead)": "fldo65PFqOY5woYmu",
    "[Engineer] Max Price Log": "fldBc6VoDkAFaPhjh",
    "Total Annual Property Management Fee": "fldnWEP0ycuRhVwum",
    "Cooking Fuel Type (from Units) (from Properties)": "fldD9Wv2ICNULKPsH",
    "Comparable Market Rent Annual NOI (from Properties)": "fld9j3MR3uNSRlnxc",
    "Tenant info obtained?": "fldeWzLNJbjAViNlp",
    "Tenant Info Required?": "fld00ZPik5DkbdIiH",
    "Other Documents from lead": "fldFi62X5ZAMAh3nT",
    "Total Current Lease Implied Utility Costs": "fldUyKMF4ocWAvjqY",
    "Unit Current Lease Implied Utility Costs": "fldoj86x2OgV1qXO4",
    "Renovation Overage Percent": "fld1jfBkUqzrF84se",
    "Selling Agent (from Lead)": "fldsD2vBRCq54CdUq",
    "Assignee (from Lead)": "fldeRKwLvAiaWuHUp",
    "Email Address (from Selling Agent) (from Transaction)": "fldYW51EhoXxU5BP7",
    "Last Modified Max offer": "fld7aeFgvxuFFGXQL",
    "Record ID": "fld9PDRXcvzJIHXzz",
    "Engineering | Renovation Budget": "fldhwjN5MGBEsgQvH",
    "Street Address (from Properties)": "fld7zyJyAXpP0IQuJ",
    "Lead Status (from Leads)": "fldiortg8r0KkRfLu",
    "Year Built": "fldnRV5Hkp9YaaV7a",
    "Unit HCV Payment Standard": "fldEphAvD1RwoeJFj",
    "Total Annual NOI": "fldokxemN6mtFKKqN",
    "Implied Cap Rate": "fldP53cV3HinnT21d",
    "Estimated Gross HUD Amount": "fldbQfnUWMsxhhgEY",
    "Contracting Agent / Seller (from Transaction) (from Transaction)": "fldyGgLQYtxkZwxMG",
    "Total Monthly Tax": "fld1DA18ezwsSVw3P",
    "Date Closed (from Transactions)": "flduKfjq9DDiwSghl",
    "Threshold NOI Cap Rate (from Market) (from Properties)": "fldGIkHweYXw2o1VX",
    "Recent Changes to ACS": "fldPqv1FVqzeeW9Tr",
    "Property: Zip Code (from Properties)": "fldinbXrHENHKIuXd",
    "Lead: Contract / Offer Price": "flddib3F8iXA1bZ8v",
    "Calculated Max Price": "fldJkuGNJhAPpNMd3",
    "Target Purchase Price": "fldjaZYRsfpDgQe1i",
    "Final HUD Amount (from Transactions)": "fldfjSQhsU6djnu8q",
    "Override Core Closing Costs": "fldmTncUeCM7UAUmj",
    "Title Insurance Buyer Apportionment Override": "fldwxJTkiEh6H244n",
    "Transfer Tax Buyer Apportionment Override": "fldO8sdppQikC3BAg",
    "Third Party Assignment Fee": "fldv7Huqanuw07qt1",
    "Total Monthly Repairs and Maintenance": "fldSrM3yvH16JskUQ",
    "Water Heater Type (from Units) (from Properties)": "fldrYVCLxsuPU1duK",
    "Satellite Preview (from Properties)": "fldNzT4CpW2qPvC0T",
    "Google Map Link (from Properties)": "fldfU8cULMHghQRs5",
    "Zillow Link (from Properties)": "fldTu4U3a52bQ9bQf",
    Inspections: "fldk7Harg6BVP0FVS",
    "Latest Offer Amount (from Transactions)": "fldKpjQN9NJSQGTSo",
    "Underwriting Notes": "fld5YeiMSFwnXFHnr",
    "Total Monthly Property Management": "fldgS48AtI9i2Bv4j",
    "Total Monthly Insurance": "fldawp6uEA51UxHAG",
    "Override Purchase Price": "fld9M7SgBdc83kPgJ",
    "Annual Tax Override": "fldDu8UcobPjzrJys",
    "Simply Acquisition Fee": "fldXUg6VmxewK9Qla",
    "Actual Renovation Cost (from Properties)": "fldh6ptPQ87GXayPc",
    "Record ID (from Properties)": "fldv3b85O0EQloh9W",
    "Total Implied Monthly Gross Rent": "fldjQCNHaFVjyd8wV",
    "Property Address (one line) (from Properties)": "fldJoA2ZlGSR0lxsm",
    "Generic Replacement Cost / Sqft. (from Market) (from Properties)": "fldrsldoMyDzcxwvc",
    "Cost per Sqft": "flds8IVfyoSKupSMQ",
    Transaction: "fldQUpQ1Jdb1ftBPY",
    "Total Monthly Asset Management": "fldUDCHyKtTgS2N6t",
    "Unit Utility Configuration": "fldQ5nSN0Wbf2UCcQ",
    "Street View": "flduuebqPTJ83cUQF",
    "Flood zone Proof": "fldxDTgirprXVs2YI",
    "Begin Time": "fldOFdnk0YI0hJP6I",
    "HCV Payment Standard Source": "fld3GAMNaF5ts5i0Y",
    "Total Annual Tax Cost": "fld5nqbeUMfhMPqRU",
    "ACS Gross Rent Received": "fldmLNEOXvrT2gwuw",
    "Property Tax Reference": "fldsBcHdLhlqrtws4",
    "Submission Time": "fldzLDXB0Z3lEjfZN",
    "Total Annual Vacancy": "fldxqB1FhkMxLdjyB",
    "ACS Renovation Amount": "fldQOTG2837bl6VrP",
    "Transaction End of Inspection Period (from Transaction)": "fldSvZPfoRW4ZH1IS",
    "Unit HCV Utility Allowances": "fld6KH9tFh4fAKmfG",
    "House Type (from Utility Configuration) (from Units) (from Properties)": "fldzfJQxkLrNi4J4x",
    "County Name (from County) (from Borough / Neighborhood) (from Properties)": "fldLfs8X1791Imm1t",
    "Current Lease End Date": "fldMmen5U9daut2AJ",
    "Total Annual Asset Management Fee": "fldEDNfMiVSpBdCT4",
    "Inspection Date": "fldzLAjpmoVviynfV",
    "Agreed Price (from Transactions)": "fldkawGBgOwxInR00",
    "One Pager Date": "fldPlEHWmL1p5eDdC",
    "Approved Time": "fldQMIAkLKGouodw2",
    "Total HCV Payment Standard": "fldhfuI2BK2F5FSrh",
    "Corelogic ARV": "fldrRYSVlV7MZDizE",
    "Estimated Total Renovation Cost (from Properties)": "fldoAQ6ChgU0TlET4",
    "Transaction: Contract Price": "fld2PUNOZzBfTVt3G",
    "Transaction Status (from Transaction)": "fld67bR5bMOCyKVLP",
    "Current Lease Gross Rent": "fldFoFAqq8CIHOnOI",
    "Total HCV Monthly Gross Rent": "fldkn1FL6x0Tef7p6",
    "Unit Monthly Vacancy": "fld004edHU5dJCArG",
    "Total Monthly Vacancy": "fld6jWnOa1lZWjeIy",
    "Total HCV Utility Allowances": "fldiJS9YNoMLuqpfA",
    "Total Annual Insurance Costs": "fldH1Jwu98iAEjne1",
    "Total HCV Annual Gross Rent": "fldhChspWxYGkG3r5",
    "Confirmed # of Units": "fldVGAryi06Gg2S31",
    "Estimated HCV Utility Allowances (from Units) (from Properties)": "fldtWNXeaTo7OVY7x",
    "Replacement Cost": "fldsxY7G5lHrE0ky6",
    "Review Time": "fldl90KpVLOzvXeoa",
    "Total Monthly NOI": "fldY22OYynUpBfmK9",
    "Total Rentometer Rent": "fldUrGdVjNytYyxLQ",
    "Contract Date (from Transactions)": "fldPCmGc2xjnAIHmn",
    "Today (EST)": "fldNoOQM6rMH0pp6C",
    Market: "fldGSjKxnD3lNrEsn",
    "Make One Pager": "fldvWYjOtsaPQir9v",
    "Inspections copy": "fldElWoE66bIYOEV2",
    "Rejection Reason": "fldLdCmEQFSdqtcCd",
    "Created Time": "fldFRO8H1bzd3uGnx",
    "Core Closing Costs": "fldE1VqsYwG97q6HH",
    "[Engineer] Max Price": "fld58PjZn3u0LxbH9",
    "Comparable Market Rent Monthly NOI (from Properties)": "fldduxBpVQnjaAqwL",
    "Estimated NOI Cap Rate": "fld70JolXvZudbkii",
    "Inspection status": "fld4qS3r9iZdDuoNo",
    "Title Insurance": "fldZYbysvWmt3ri88",
    "Lead Created Date": "fldzQ6FqJxMalnMaI",
    "Zillow Link Button": "fldkcw8XxWv3MQMjR",
    "Google Map Link Button": "fldadxw9XU9QIDCet",
    "Estimated Total Renovation Cost": "fldgfAGBxgMnizrmf",
    "ACS NOI (Annual)": "fldi3FLKHUgO7RW5S",
    "Now (EST)": "fldyLrj7GuDKeradZ",
    "Last Modified AC Status": "fldoYfPTnmI7IXKCD",
    "Total Annual Repairs and Maintenance": "fldyLrw7W5JMihHWd",
    "Photos Link Button": "fldxebNf8n7QD0Re9",
    "Google Drive Public Photos Folder Link (from Properties)": "fldFhxmFMiuA19diM",
    "Heating Source Type (from Units) (from Properties)": "fldPPsKHkMPyUFXHq",
    id: "fldZoLQTjgYrLhaIz",
    "Lease Type (from Units) (from Properties)": "fldNgbalyz0s4uqwd",
    "Listing Agent (from Lead)": "fldYRs7AFjxWj3Gwd",
    PSA: "fld61C0DzY1JfS1ga",
    "Current Lease": "fldO4rDgqUZUtffLF",
    "AIO Link": "fld9gpojTFah02rhc",
    "Vacancy Status (Listing)": "fldJk90GXNSAnSYUr",
    "Total SqFt": "fldHppJPPIafpM3lv",
    "Estimated Closing Date": "fldHQXUKCAIZCDECE",
    "Inspection Report": "fldrNbolCWc6iYuuF",
    "Notes (from Inspections)": "fldKOutv1AMBV3Q0L",
    "Inspection Photos (from Inspections)": "fld6gSQjh6I6BWquJ",
    "Borough/ Neighborhood Name": "fld8wmWtnZxnRZi2H",
    "Inquiry Time": "fld0uefG7vFU9lN0X",
    "Originator Override ARV (from Lead)": "fldRdTnJHKU9p5NoI",
    "Originators BPO / CMA": "fldIkmWod9cDbRnY3",
    "Threshold of ARV Uplift (from Market) (from Properties)": "fldu4pFGDMLuC0R4R",
    "Override Percentage PM Fees": "fldGGZtGAPFj9eUp5",
    "Asset Management Fee Override": "fldQ6k7cXLIWtWSuu",
    Units: "fldMWAM6ECYOmabeH",
    "ACS Approved Offer Amount": "fldpzL87HguS539Gx",
    "Max Offer Amount": "fldyHvUvkbBMl7T9D",
    "Unit Beds": "fldUOKpZEDIJtUmeq",
    "Total Bedrooms": "fldHGzLjKATpheUMd",
    "Unit Bathrooms": "fldIVIl4g3LR4KtkK",
    "Total Bathrooms": "fldLklepde0vdNT0h",
    "Current Occupancy": "fldpWfaaC5tCPPVWp",
    "Rentometer Rent": "fldrUDHEZtr8jDgs3",
    "Current Leases": "fldFYoJa0HmNy81NW",
    "Unit Monthly Asset Management": "fldGTOJvfA5Uq3iZ2",
    "HCV Payment Standards (from Units) (from Properties)": "fldVt8v9gN9sKWtN2",
    "Comparable Market Rent NOI Cap Rate": "fld3UWRIQ8SQhD3JV",
    "Water Type (from Properties)": "fldCRNuDSMv5w395m",
    "Sewage Type (from Properties)": "fldsoenyqlV1vI9jN",
    "Asking / Listing Price (from Properties) (from Transactions)": "fld2LVY8XVsm0Sjfp",
    "Simply Override Acq Fee": "fld94RR2krMVUhsSQ",
    "Transfer Taxes (from Market) (from Properties)": "fldHZQk45Um8pviIA",
    "Transfer Tax Buyer Apportionment (from Market) (from Properties)": "fldmO5U6SYivNhY3I",
    "Title Insurance (from Market) (from Properties)": "fldpR384hznWBb93E",
    "Title Insurance Buyer Apportionment (from Market) (from Properties)": "fld0YKG9UaNKnecfq",
    "Transfer Tax": "fldDuenKd9pW72txC",
    "Gross HUD Amount": "fldb8d3ygn0n645VA",
    "All In Cost": "flddzAKvN6TJGVS5b",
    "Housing Authority": "fldr02B2jWFvisB5o",
    "Property Manager (from Properties)": "fldZy2X2Os2KIjSBB",
    "PM Onboarding Costs Per Unit": "fldi7by46eMbnsCIZ",
    "PM Reserve Amount Per Unit": "fldfTqMw4dvY24TCE",
    "Actual Monthly Insurance Premiums": "fld4F7mXIPcMyGAqO",
    "ACS Gross HUD Amount": "fldkjzgiA6gVPj8fi",
    "ACS All In Cost": "fld9TEECjmeuGN38v",
    "ACS NOI Cap Rate": "fldZm8VUxQzmUcQnT",
    "Equity Cash on Cash": "fldKeWiLczroWkidd",
    "Number of Units": "fldStG9fyyowy5HKu",
    "Ownership Reserves Per Unit": "fldp1LnvdNFk4emrc",
    "Owner Reserves Total": "fldvsbFjgB82puZnl",
    "Total PM Onboarding": "fldnuyAEcB47Yr4UX",
    "Borough / Neighborhood": "fld0Gs8tEYpKxqqrY",
    "Insurance Company (from Properties)": "fldwsUpWkyQUHvXQV",
    "Purchasing Entity": "fld3olL7pHMsWMP3p",
    County: "fldp5rjhIZ1SbeF0k",
    "HCV Rent Reference": "flda80KSMjmZ7T956",
    "Flood Zone": "fldso46WUISEojnBv",
    "Offer Type": "fldWhaY7uPlgoVjFk",
    "Reno Estimated TTC": "fld8Yilb7FuDz3COv",
    "Total PM Reserve Account": "fldoL4fcR2a6KF3yj",
    "Zip Code Average Home Value": "fldXKY3YqkQ298yra",
    "LTV Percentage": "fldq3M6HzoLexe29Q",
    "Loan Rate": "fldtfTkPsY5dSwjCO",
    "Additional Ownership Reserves": "fldh1RGghYJI3aLkU",
    "Total Closing Costs": "fldvkfTKCe1HiXQge",
    "ACS Approval Date": "flds4Bkey7Z80JST4",
    Name: "fldogIVaMdAj3BMf0",
    Underwriter: "fldxG37F0NOcZZiqk",
    "AC Status": "fldKzoCHZlgyI6WDK",
    Properties: "fldZnekb8r82Aykoi",
    "Estimated Acquisition Costs": "fldduo6BkLO3SxYot",
    "UW ARV": "fldF0XXwsf5icqefr",
    "ARV Uplift": "flduhb0D8Lw2xSZa4",
    "Debt Quantum": "fldjLry4Rrc6lrTII",
    "Interest Costs": "fldvap3Q79hMEmb0m",
    "Equity Cashflows": "fldll2kWqZG0HmdXF",
    "Housing Authority Name (from Housing Authority) (from Properties)": "fldMhYhpUI1ZuZktj",
    "HCV Rent Reference (from Housing Authority) (from Properties)": "fldC8MyfboAt8LbYt",
    "Renovation Status (from Renovations) (from Properties)": "fldMeICDr2f23AEYR",
    "Leasing Status (from Units) (from Properties)": "fld5bw7e6Ew4dR1s0",
    "Source (from Lead)": "fldWFXGzB5tbQMF17",
    "Asking Price (from Lead)": "fldIiLhCW7uckqlbU",
    "Legacy Photos Link Button": "fldJ7p9hF33VUpkQZ",
    "Regenerate Max Offer Button": "fldzMP3CykWdmB3eI",
    "Renovation Cost Override": "fld3u3hiJdH3wTrNu",
};
exports.SHu_const_airtable_markets_fieldIds = {
    name: "fldBq6G8BN0D6eybJ",
    defaultTaxRate: "fld0B1MYfStMN8InJ",
    defaultTaxMultiplier: "fldssjgZ9oz5XNCNz",
};
exports.SHu_const_airtable_engLocalities_fieldIds = {
    "Utils Source": "fldFeYyvG0tgb4UN4",
    "Default Multi-Unit Type": "fldhADtt4skg7Wa93",
    "Default Single-Unit Type": "fldtJzIbXjRb4jf7D",
    "Utils Period": "fld8pGtDtbkFGFfnc",
    "Rent Source": "fldlUp0b9Poh0v6J5",
    Properties: "fldPtkHyX9A9FN4m5",
    "Neighborhoods / Boroughs": "fld56VVpKP1NYaTyb",
    "General Contractors": "fldDjgRgheavtOTVM",
    "Utility Companies": "fldx4nfc1ioImoSce",
    Contacts: "fldpUhFnLrQp24yL8",
    "Transfer Taxes": "fldMoMChHhLFWrd3A",
    "Transfer Tax Buyer Apportionment": "fldCaJCG26fk5JDk4",
    "Core Closing Costs": "fld3EaTH8tLpJN0Yl",
    "Title Insurance Cost": "fldP7j5gxtgND5rlo",
    "Title Insurance Buyer Apportionment": "fldYsjtW8eEa1StCI",
    "Housing Authorities": "fldDq6t2n90budrIh",
    "Repairs and Maintenance": "fld9ELkY4MCII5TQP",
    "Asset Management": "fldFqMUAGLgxoxYXo",
    Name: "fldCX8vJfojLUAnY3",
    Notes: "fldsDDwmLUdcmQKJX",
    Status: "fldnYYdIjTkfLGODk",
    "Broker Partner": "fldqICPey5vxIPJ9A",
    "Broker Partner Agreement": "fld0DTa7upMhHmAIu",
    "Market Manager": "fldMfuba1OhyYwPah",
    "Project Manager": "fldKLFWh4gIrYJkkI",
    "Property Manager": "fldYVT1Ju7ftKau75",
    "Threshold NOI Cap Rate": "fldmtdqZWcpbSdAFU",
    "Buyer Entity": "fldvzanlxlSYe5z9j",
    Vacancy: "fldddvve6IkT1MXh3",
    Insurance: "fldjKeC8husgqVYRg",
    "Asset Manager": "fld1wyeaMCZrjuJvb",
    "Origination Officer": "fldr1gCgnO4hlCjdf",
    "Internal General Contractor": "fldbevZka7G4Ajpsv",
    "Assumed LTV Percentage": "fldKsNdNoCMM6wLda",
    "Assumed Loan Rate Percentage": "fldWbyYLSd6aCSqXv",
    "Mailing Address (from Property Manager)": "fldLghMdJqpIr4TrX",
    "Phone Number (from Property Manager)": "fldPAMjH9QHfy18YT",
    "Email Address (from Contact) (from Property Manager)": "fldY8LXzPfXcqtIRb",
    "Contact (from Property Manager)": "fldMBtiLp9HXa6JzE",
    "PM Fees (from Property Manager)": "fldk6XSWNRNXnGi0i",
    "PM Onboarding Fee (from Property Manager)": "fldlB8CcVtrTAI9hJ",
    "Minimum Reserve Amount (from Property Manager)": "fldjwbGjMMz3jbtHc",
    "Default Buyer Entity": "fld2y4i58Ecgm9pSP",
    "Generic Replacement Cost / Sqft.": "fld7cTP6R02zRLfDE",
    "Mobilization Funding": "fldy0FxjmRtaMHxgG",
    "Templates and Documents": "fldJ7M9lDjTKYyJUb",
    "Seller Due Diligence Request Forms": "fldyykeaGIicmOArR",
    "Title Diligence Checklist (from Templates and Documents)": "fldrFXcT244J1Xl2Z",
    "School Zone": "fldwXI307R42R3UTi",
    "Threshold of ARV Uplift": "fldoB8TAYT3W9KmV0",
    "Housing Authorities copy": "fldoOPtHe0JEzUqOc",
    "Engineer|Default Tax Rate": "fld183BzTtMUBuxa3",
    "Engineer|Default Tax Multiplier": "fldtZl5ANZSdL9rAT",
    "Name (from Property Manager)": "fldarn5YAuFAbEHow",
    State: "fldmYiDa9nlHzbwDO",
};
exports.SHu_const_airtable_engGeoids_fieldIds = {
    geoid: "fldYgyXmwVbcWYnNI",
    Notes: "fldf1x9jQSz5LmUaI",
    Locality: "fld8QVvkSPYMyN9rN",
    State: "fld5vjmmC1xZ2tZpq",
    Name: "fldox6ahw5e0w0z35",
    type: "fldQww4TNhLwA8Xi4",
    "Attom JSON": "fld0OClvcQwhzl3d4",
    Properties: "fldza66vGUH9YpU5d",
};
exports.SHu_const_airtable_units_fieldIds = {
    Leads: "fldHw02j25wOObozw",
    "Engineer | secondary triggers": "fldwdnr1G2GSIqeho",
    "Final HUDs (from Transactions)": "fldXkMUlCICkSwTXj",
    "Acquisition HUD Statement (from Final HUDs) (from Transactions)": "fld2WZFMcgfiZnkqI",
    "Listing Published Date (from Rental Listings)": "fldkB5CWFxWdiuL0r",
    "Tenant Selected Date (from Rental Listings)": "fldKn0NfKj2gMz5Md",
    "Lease Signed Date (from Rental Listings)": "fldl3w6EckR30tEF1",
    "PM Walkthrough Date (from Rental Listings)": "flddEGaL1DW8VSEIq",
    "Account Type (from Utility Accounts)": "fldmDLIft4EzXAuDm",
    "Utility Accounts 2": "fldptxQh07sB1UEs7",
    "Daily Units Status Reporting": "fldG1KpXTDTU0tCb5",
    "Daily Units Status Reporting 2": "fldQDHIUS1uhcCKIV",
    "Daily Units Status Reporting 3": "fldTJirBPPGllHMl3",
    "Daily Units Status Reporting 4": "fldsx0zPRa3KlCX1M",
    "Daily Units Status Reporting 5": "fldHr4yjkqWCmVU1g",
    "Daily Units Status Reporting 6": "fldgKxiuefTqguANi",
    "Daily Units Status Reporting 7": "fldmWVEk2i4Vgj3EA",
    "Rental Registration Permit": "fldz8nx3ASVKye0ko",
    "Rental Registration Expiration Date": "fldDw3s6A5Yi6Wj8i",
    "Operating Status": "fldogcrVf2GRp3QjB",
    "Electric Meter Number": "fld0cPYDHbrBQjbzY",
    "Electric Payor": "fldSpQHicih7Q3yqg",
    "Gas Account Number": "fldtsI4WSFH35hyHJ",
    "Gas Start Date": "fldPSkG5vObbED8La",
    "Market (from Property)": "fldKyCzP3uUJTRIir",
    "Housing Authority (from Property)": "fld6J9hwAhcZkR8K5",
    "Renovation Status (from Renovations)": "fld9uxebtUERx2lKt",
    "Cooking Fuel Type": "fld1M5Jr5mYvMdy3k",
    "Heating Source Type": "fldjcXpxXpiyj49A4",
    "Photos and Video Link": "fldrliYdGgYaWQ0Bt",
    "RFTA Document (from Tenant) (from Current Lease)": "fld72kv5rCCryEUf7",
    "RentoMeter Market Rent": "fldGeDqCa841VjyJA",
    "Estimated Monthly Rent Override": "fldoVVNidzy0VQwWy",
    "Estimated Monthly HCV Utility Deduction": "fldJycu6kKcPtUVKE",
    "1 bed (from Tract) (from Property)": "fld3dvvhHxHqU4YE2",
    "3 bed (from Tract) (from Property)": "fld71w8SHurI1jAHC",
    "4 bed (from Tract) (from Property)": "fld2ZHzikWuazhKcm",
    "6 bed (from Tract) (from Property)": "fldazxRk3wl2V1J6n",
    "Property Classification (from Property)": "fldIF9CI85TL16AQr",
    "Utility Allowance - Electricity Customer Charge (from Utility Configuration)": "fld0fkVLYPVwq93SP",
    "Utility Allowance - Microwave (from Utility Configuration)": "fldgZjtGOXe1NGSlQ",
    "Utility Allowance - Trash (from Utility Configuration)": "fldYymqxSBgE16873",
    "Utility Allowance - Cooking Electric (from Utility Configuration)": "fld8bzQ1KGLPmYBWf",
    "Utility Allowance - Cooking Bottled Gas (from Utility Configuration)": "fld3xnfLloIcMhAW3",
    "Utility Allowance - Cooking Natural Gas (from Utility Configuration)": "fldiyNCKSaaMsRS1j",
    "Utility Allowance - Heating Electric (from Utility Configuration)": "fldmAzngj9EnGiqFL",
    "Utility Allowance - Heating Oil (from Utility Configuration)": "fldXgmvwNvEfDEUrt",
    "Utility Allowance - Heating Bottled Gas (from Utility Configuration)": "fldkDuiwR3JzatOkR",
    "House Type (from Utility Configuration)": "fldI200RuMErokzWI",
    "HAP Contract End Date (from Current Lease)": "fldnFYywzKWOZhl75",
    "Water Account Holder Name": "fldcRsMVgLGD9zBAY",
    "Utility Allowance - Range (from Utility Configuration)": "flduuPkGmIxPfb6cd",
    "Utilities Sheets (from Utility Configuration)": "fldEKZDjFoZJtKIAx",
    "HAP Contract Start Date (from Current Lease)": "fldAborwpCc9apK4f",
    "Number of Units in Property": "fldET7gSqH0fK9AXI",
    "Unit Supplied Microwave": "flddQAZOaiNKlQhwy",
    "Utility Allowance - Water/Sewage (City) (from Utility Configuration)": "fldk0yG2fKunYsYXN",
    Underwriting: "fldaD4U1OhrDb356C",
    "First Lease Date (Under SH Ownership)": "fldSLPJG2ma1dY151",
    "Time between Prepare for Market and On Market": "fld93ZrrPAproITI1",
    Created: "fldfT8G6VquRlI10m",
    "Property Management Fee % Override": "fld5I3FDIH3AyKkgf",
    "AC Status": "fldUYmLDIP2mn1sKE",
    "Email Address (from Tenant) (from Current Lease) 2": "flduGtz3hlIgNB5Lg",
    "Name (from Tenant) (from Current Lease)": "fldqd7dC9kMlXDY7W",
    "Name (from Trash Provider)": "fldx4qxB06wPXjBxM",
    "Name (from Gas Provider)": "fldS5JmNpE53P4XY1",
    "TEMP - Utility Migration Notes": "fldryFIY3n4zXMJsA",
    "Market Rent Monthly Property Management Fee": "fldLqdTkVrL26vhNo",
    "Electric Box Type": "fldgEJIlaGioQDbmD",
    "Bathroom Floor type": "fld9IJfXc6K0D5kqy",
    "Refrigerator Photo": "fldAFgaoOo56Z7Xvc",
    "Time between Tenant Selected and First Lease Date": "fldL2aGTmFVSGiyY1",
    "Estimated Monthly HCV Rent": "fldjWZuV5kmFtAKhg",
    "5 Bedrooms (from Zip Code) (from Property)": "flddt5fjEhd6MiC9N",
    "Appliance Utility Allowwance": "fldW3MX5j8XRt0jzi",
    "Utility Allowance - Water/Sewage (City2) (from Utility Configuration)": "fldI2yY9PessbTk13",
    "Electric Meter Photo": "fldIWkROp9aJ7xs2w",
    "Archived Leases": "fldpuiYFLHHqG02y5",
    "Lease Subsidization  (from Current Lease)": "fld7PR6PMJvHIUUOR",
    "Rental Listings": "fldR0dtu9S5jsFerf",
    "PM Walkthrough Date": "fldkjvjzhyFSnBZYW",
    "Date of First Showing": "fld9FIITCFQwxiIuk",
    "Date of First Applicant": "fldCKqJwtBKeCEoNl",
    "Property Manager Onboarding Costs": "fld0PZb6eyvyNrJ0c",
    "Name (from Default Property Manager)(from Property)": "fldHy7r8GpJewLFmn",
    "Deed of Transfer (from Transactions)": "fldfr2gpVju8PyVPP",
    "Utilities Setup Complete Date": "fldORh8dtfHSyDCGu",
    "Utilities Onboarding time": "fldcEFAKROqepYQbC",
    "External Inspections": "fldvnQ8w6EBrjSw4U",
    "Adjusted Simply Utility Cost": "fldYwprYZNKR0GI6K",
    "Current Lease Monthly Vacancy": "fldMjOpUSV0pAmRyj",
    "Current Lease Monthly Property Management Fee": "fldworlhnxtinTGqF",
    "Next Steps (from External Inspections)": "fldyVzklHWOmihWWx",
    "Gas Status": "fldeP90AFWEOUk95A",
    "Estimated Monthly Gross Rent": "fldLlOrlpif5Hh6b1",
    "Estimated Renovation Completion Date (from Renovations)": "fld6Zbhsemc2hEEQW",
    "Utility Allowance - Refrigerator (from Utility Configuration)": "fldXBYRthOddxpgsD",
    "Utility Allowance - Other Electric (from Utility Configuration)": "fldauiBUen4nEYspF",
    "Seller Utility Form Response (from Transactions)": "fldPkOXmgc5MCsjeh",
    "Current Lease Monthly Asset Management Fee": "fldvtr3cQ2xOi0NsC",
    "Outcome (from External Inspections)": "fldVjlN82yoBcBbPR",
    "Status (from External Inspections)": "fldrQyHU8YpuAfveN",
    "Appointment Time and Date (from External Inspections)": "fldNN3zgeUVI6apow",
    "Deed of Transfer (from Diligence) (from Property)": "fldzmp2PVqMmD6G6K",
    "Utility Allowance - All Gas Option (Heat and Cooking) (from Utility Configuration)": "fldY28iuPrnKwPnZY",
    "Utility Allowance - All Gas Option (Water Heat) (from Utility Configuration)": "fld0c5wByzqpYxIK8",
    Property: "fldkSCXCYeq0hpdqu",
    "Inherited Tenant": "fldzk5m07h8EJHpY4",
    "Has Air Conditioning": "fldkObe76BV9kvKwD",
    "Actual Renovation Completion Date (from Renovations)": "fldXPZdBmDEAtFlsi",
    "6 Bedrooms (from Zip Code) (from Property)": "fldnL3sOFKnijbytx",
    "Housing Authority Name (from Property) 2": "fldOsytNgVeQStfKU",
    "Water Supply Pipe Type": "fldu5pzizSZw1hIZz",
    "Leasing Notification Contacts (from Property Managers) (from Property)": "fldRNxqaEs91LitEi",
    "Renovation Type (from Renovations)": "fld9eJXtyrZgXvBSu",
    "Property Taxes": "fldlBIivA86ArZrlA",
    "Trash Account Holder Name": "fld9buj1deA42pe72",
    "Utility Allowance - Water (from Utility Configuration)": "fld5OYX9pSVFEBffj",
    "Utility Allowance - Water Heat Bottled Gas (from Utility Configuration)": "fldMD6Zdf8pLq1rc5",
    "Name (from Water Provider)": "fldgdhoU4bTEKpvDV",
    "Change of Closing Status Modification time (from Transactions)": "fldfHWhll3u1up6pq",
    "Rental Detail Note for In-Market Advertising": "fldDfvPxGRcl7IsK3",
    "Borough / Neighborhood (from Property)": "fldyzXROW9LXYqDrv",
    "Last Modified": "fldpCVmOhOrrE87O5",
    "Name (from Sewage Provider)": "fldAmY6daoyVIA9c2",
    "Unqualified bedrooms (after Renovation) ": "fldlsCfcUPTZDTyOx",
    "PM Tickets": "fldmPJsUpUCvffWjn",
    Walkthroughs: "fldkmSnKuYqRDZjTi",
    Occupancy: "fldXaKxmACuZPCpcO",
    "2 Bedrooms (from Zip Code) (from Property)": "flddzlWqBmIyoaki9",
    "5 bed (from Tract) (from Property)": "fldaF0Ddjdl6XQNt5",
    "has Knob and Tube": "fld2z71pOkp0t9s4c",
    "has Aluminum Wiring": "fldMU5uaTse8oJK5W",
    "Certificate of Occupancy": "fldgGqIbitCGHNJbP",
    "Email Address (from Tenant) (from Current Lease)": "fldROOKdSICtDGjhi",
    "Utility Allowance - City Trash (from Utility Configuration)": "fldLbLfsvhJO2N9i5",
    "Unit Supplied Range": "fld8iv7AHpNWbPbns",
    "EIN (from Owner Entity)": "flde6OoZUuGJK3IOa",
    "Utility Accounts migrated?": "fldd6RB5G0BVHRoNK",
    "Air Filter Latest change": "fldLStCcocI7l1ihq",
    "Added bedrooms": "flde0BDaheGFkW7rf",
    "Leasing Status": "fldDD0M2yR8r9Rf3V",
    "Additional Payment Notes": "fldLLqiCbnKY6Iom3",
    "Monthly Asset Management Fee": "fldl7rTE2AIf2PAPS",
    "Water Heater Type": "fldQ1noSO2dvxbd0G",
    "Name (from Housing Authority) (from Property)": "fldWoHEz9uYIE4EqR",
    "Outlets types": "fldiixiqItruTnenh",
    "Oven/Range Photo": "fldSEEJAqBSRvRvZU",
    "Creation Date (from Rental Listings)": "fldyXka9qxfMIT6vv",
    "Water Start Date": "fldXogg6zmPiPVO8q",
    "Utility Configuration": "fld5pjxRGkDu3rbfC",
    "Trash Payor": "fldkETNgffc0NxbrJ",
    "One Line Address (from Property)": "fldjM3ED8LMhhzZz8",
    "Monthly Property Management Fee": "fldGQoxQL4xxRYHzX",
    "Utility Allowance - Sewage (from Utility Configuration)": "fldUmpadxSynWgoiA",
    "Water Utility Allowance": "fldwl0n8FisqvC3Ek",
    "Violation of Pet Policy Fee (from Property Managers) (from Property)": "fldGdSYwptNuBdGEp",
    "Date Closed (from Property)": "fld9fZcuuReUAS4Af",
    "Refinancing Posture  (from Property)": "fldRipcDqnhdguLTM",
    "Intended Strategy": "fldqY7Hbi9qORHKAW",
    "Efficiency (from Zip Code) (from Property)": "fldXclLMvKxdEChmb",
    "Unit Supplied Refrigerator": "fld82PKqC7yD8VtJc",
    "Property Record ID": "fldsMHyBAazou5L4q",
    "Rental Registration Required": "fld1JoR7TVTEC7UIq",
    "Air Filter Details": "fldSINCjDjEODgoXT",
    "Late Fee % (from Property Managers) (from Property)": "fldJxGTRzcppJxzcz",
    "Name (from Property Manager) (from Property)": "fld20xEYscV4RV4ek",
    "Market Rent Monthly Asset Management Fee": "fldqwhoXPEVem5tYv",
    "Approximate Unit Sqft": "fldbwqYspHDdkulfL",
    "Acquisition HUD Statement (from Transactions) (from Property) 2": "fld85aXfRoIRkpeCJ",
    "Unit Name": "fldvUg4iwSyhZ32ti",
    "Electric Note": "fldEqryuCe9Q6Hkg6",
    "Lease Start Date": "fld4jCeUXMvO2qaVZ",
    "Tenant Payment Amount": "fldjXRc63SFoYnNtD",
    "Additional Payment Amounts": "fldNp9m2gbPU2740o",
    "Utility Allowance - Water Heat Natural Gas (from Utility Configuration)": "fldeZWfbni7lRUund",
    "Unit Configuration (from Utility Configuration)": "fldf0YuYRD2fc5QzK",
    "Rental Registration Last Date": "fldTWjzFq9paYqDmK",
    "Name (from Market) (from Property)": "fldPB1pT15eeUEPjR",
    "Square Feet (from Property)": "fldGS0MHaE5iaFS4M",
    "Closing Confidence (from Transactions)": "fldyYvpMjynzKmxNa",
    "Trash Provider": "fldkTHW8HnLf18vjJ",
    "Transaction Status (from Transactions) (from Property)": "fldGd2Odt4CQvplTo",
    "Leasing Notes": "fldAqSKIy17myreds",
    "Unit Notices": "fldapQqYE4voLZ7xf",
    "Adjusted Actual Gross Rent": "fldUOoh154Bvi6fqA",
    "Gas Meter Number": "fld6BtGEu5nT3LpGY",
    "Lease Documents": "fldk6yAjEpqYkbSIk",
    "1 Bedrooms (from Zip Code) (from Property)": "fldBXEufaJxinINX9",
    "3 Bedrooms (from Zip Code) (from Property)": "fld5G1K7SYnnoauMQ",
    "Electric Utility Allowance": "fld7eW66zkG2SDFa4",
    "Utility Allowance - Water/Sewage (Suburban) (from Utility Configuration)": "fld67AWclFiXu4Iej",
    "Monthly Gross Rent": "fldAfwPSxuTNexWo1",
    "Utilities Remaining in Setup ": "fldfdpUO2QuhcAOZC",
    "Utility Allowance - Water Heat Electric (from Utility Configuration)": "fldGiLHjnxqQ2wyxw",
    "Housing Authority Name (from Property)": "fldIxsTLsDrp6pMHA",
    "Trash Note": "fldUjFEaGOjeLcj1F",
    "Electric Account Number": "fldVmcVEIDcPW7zHI",
    "Gas Payor": "fldDG4PQhEocRqkIU",
    "Water Status": "fldtOKoOrdpdCeGu2",
    Transactions: "fldKd1BNpewqgomRu",
    "Last updated": "fldbH2DqRWiGLOnTP",
    "Name (from Borough / Neighborhood) (from Property)": "fldnnOPSeJTwmmlfr",
    "Name (from Electric Provider)": "fld2ExceLF1oFouba",
    "Time On Market To Date": "fldgCcb4Jb67O0We2",
    "Owner Entity (from Property)": "fld0Liz2Hl0x2vIrT",
    "Current Tenant": "fld23ZuhDQwOGbcdt",
    "Renewal Date": "fldUoZegrdgPuOqys",
    "Address Override": "fld3uOldWzGLhzazr",
    "Efficiency  (from Tract) (from Property)": "fldiOJP6v503WbJWz",
    "Utility Accounts": "fld2lNQcH5AY3al3q",
    "2 bed (from Tract) (from Property)": "fldYri0KN8737G5Jl",
    "Utility Allowance - Heating Natural Gas (from Utility Configuration)": "fldRmaNb2dKlI6exR",
    "Sewage Utility Allowance": "fldWA86mNgN4x8UTY",
    "Electric Status": "fldqTdYvxM9Vg9SDL",
    "Monthly Vacancy": "fldT9BOrCnRcfCKAv",
    "Reference Name (from Housing Authority) (from Utility Configuration)": "fldR8TfBr36MFWEk6",
    "Trash Utility Allowance": "fldIqk5tUTfAemRs0",
    "Pet Fee (from Property Managers) (from Property)": "fldyU3kl6tYM2LmMw",
    "Sewage Type": "fld5DfP9dPkXBmnVC",
    "Status (from Rental Listings)": "fldNW8Yij4zisMcB1",
    "Electric Start Date": "fldFLI4514qOshFpd",
    "Leasing Links": "fldl990vePbB7z2op",
    "Unit ID": "fldiclubv7XIcCPbp",
    "Simply Utilities": "fld2otUkddtAOoXCP",
    "Water Source": "fldqwhKPY07AjuCS3",
    Bathrooms: "flds4uQgetioz0Xm8",
    "Sewage Account Holder Name": "fldkoqxaWYXBbwgSX",
    "Electricity Account Holder Name ": "fld216of75FmhbimZ",
    "Calculated Tenant Utility Allowance": "fldTHAzAgKLAekgOq",
    "Lease Signed Date": "fldnzO0UrNk35xkKq",
    "Tenant Utilities": "fldaHRtmzcSeqt5uF",
    "Property Manager (from Property)": "fldiYxDpe4C5bk85A",
    "Gas Account Holder Name": "fldKGlzzHgKTJWe2l",
    Bedrooms: "flddkNUd7ht9raHL3",
    "PM Fee Percentage": "fldgOaw01V5h1Q90D",
    "Acquisition HUD Statement (from Transactions) (from Property)": "fldVenZgOZitzEENU",
    "Utility Allowance - Water Heat Oil (from Utility Configuration)": "fldcJNWfAlHyLZBb5",
    "Utility Allowance - Heating Electric (Heat Pump) (from Utility Configuration)": "fldtBLP7klmbctlIL",
    "Market Rent Monthly Vacancy": "fldb76gvedMrAVoVl",
    "Water Meter photo": "fldmvQXTHJpIGtSLV",
    "Utility Allowance - Air Conditioning (from Utility Configuration)": "fld4psW9VuKCQLEIz",
    "Gas Utility Allowance": "fldnagvAih1ebmjmD",
    "Lease Modification Fee (from Property Managers) (from Property)": "fldGjpoFEeLQ3RMUC",
    "Time Since Prepare for Market": "fldZdq5My4BLNeVpD",
    "Time between On Market and Tenant Selected": "fldCdXvl8rcI6bnXx",
    "Name (from Utility Configuration)": "fldEPvpeO9wQz7m8H",
    "Allowed Vehicles ": "fldLvPRpHM2OXOtPF",
    "Move in Fee (from Property Managers) (from Property)": "fldHACEw9wIeAHWyx",
    "Daily Late Fee  (from Property Managers) (from Property)": "fldhtqvic9KqSTD0G",
    "On Market Date": "fldSTd8sxvIxk6psN",
    "HCV Status": "fldctJnlUPQGC5nnY",
    "Utility Status (from Utility Accounts)": "fldjgAvsYOqcKVmth",
    "Gas Meter Photo": "fldMc7C8IolN3S5Lc",
    "Kitchen Floor type": "fldO5YphKO6aNj85C",
    "Year Built (from Property)": "fldCR8A316EJoFGz1",
    "Record ID": "fldPh9MMdl6qF1fJG",
    "Google Map Link (from Property)": "fldz1eyq11UbYokGY",
    "Streetview Map URL (from Property)": "fldJPWyEo4qq4zKAX",
    "Streetview Preview (from Property)": "fldK400rbJ3GTmWNB",
    "Satellite Preview (from Property)": "fldAdwjjFcmkgoRx3",
    "Streetview Map URL Button": "fldbTnwbgywASRGuB",
    "Google Map Link Button": "fldLss7p8WG3ahYv3",
    "has Laundry (from Property)": "fldA1VYVQ1Gm8I4Tt",
    "has Porch (from Property)": "flda8VEAFVPGu8BwP",
    "has yard (from Property)": "fldWz4qvAGPlpowD1",
    "has driveway (from Property)": "fldBVQ4U2ojNtgI2K",
    "has sidewalk (from Property)": "fldXK3OtliTZFmz4u",
    "has patio (from Property)": "fldJ8HT1Sb2EkMXux",
    "has deck (from Property)": "fldBQhBtqBUM2qxId",
    "has Off Street Parking (from Property)": "fld6Lr4aVjSTw8Ass",
    "has Basement (from Property)": "fldfE12SSKiyWb03g",
    "Has Garage (from Property)": "fldbNV1KM7Z8RLHph",
    "BTU Of Heater": "fldglt2cefJPcBCrQ",
    "Unit Identifier": "fldiSW4aZYZu5YYDV",
    Renovations: "fldWkeQ1iZrotvn96",
    "Street Address (from Property)": "fld0meZG40S3psvfe",
    "Current Lease": "fldKW6qrLWQ9bD6bF",
    "Asset Management Notes": "fldDlkV0BTZwJ50AE",
    "Unit Access": "fldAJWmYpSLbFAHlV",
    "Walkthrough photos / Links": "fld7rGUlrMKN3fkEk",
    "Utilities Transferred": "fldsyRVyIcv6K5Q7o",
    "Water Provider": "fldhhQLENf75hO0Gs",
    "Water Account Number": "fldpFEaQZZweBopiK",
    "Water Meter Number": "fldXVwH8v8ZP1notc",
    "Water Account Note": "fldbg7SeggnchXRFM",
    "Water Payor": "fldWyFNFhgk1BZgFl",
    "Lease Type": "fld0BXEbEQjyCLaAU",
    "Move-In Date": "fldt4vzMe5lrV8VQc",
    "Lease End Date": "fldPCNTGTeZhzvd2U",
    "Housing Authority Documents": "fldnC5o7pCUlscxWY",
    "Housing Authority Payment Amount": "fldTTac6c2Y2E3mvM",
    "Estimated Closing Date (from Property)": "fldojbGNY9uEXpkkc",
    "Pre-Inspection (from Renovations)": "fldxvI18y3FuXVMep",
    "Mailbox ID": "fldRpdvzgjzD4qDu7",
    "Rental Registration Cost": "fldho5ICu623d1zK5",
    "Rental Registration Renewal Frequency (Years)": "fld2lCqnCa7MdjXyA",
    "Payment Location  (from Property Managers) (from Property)": "fldwMufT3b8NPM4KH",
    "Pet Deposit Amount (from Property Managers) (from Property)": "fldqKhKYs4scgXPUe",
    "Grace period (Late Payments) (from Property Managers) (from Property)": "fldodDvSL5osd8LkW",
    "Late Fee Min (from Property Managers) (from Property)": "fldh7mfotoPJXwRsO",
    "Sewage Provider": "fldk86B7vxH9YR1Te",
    "Sewer Account Notes": "fldNvRLSyqLrOahX4",
    "Sewer Account Number": "fldxkRPILiG5tiPk4",
    "Sewer Start Date": "fldSRESYWMQ4CApUd",
    "Sewer Payor": "fldK0KcRI0FoeBVNS",
    "Trash Account Number": "fldOC8t0tHay0PlWb",
    "Trash Service Start": "fldpfz78R40qKyUOW",
    "Electric Provider": "fldhFkdcrPQ9cbfiS",
    "Current Lease Rent Amount": "fldkSWbme2ZTmA2E4",
    Notices: "fldeurGANpQOFzRZN",
    Applicants: "fldbkd63dUClU8TQI",
    "4 Bedrooms (from Zip Code) (from Property)": "fldPNt170OUpWXBx4",
    "Tenant Selected Date": "fldph9yVmhmPRDEzg",
    "PM Tickets / Events": "fldTDIwJWNR0n7Ukk",
    "Notes (from External Inspections)": "fldN6rQcqQWkfttTC",
    "Gas Provider Note": "fldoFv1XNIOJdvYDJ",
    "Prepare for Market Date": "fldei3TpMH6MqF4fp",
    "Estimated Closing Date (from Property) 2": "fldR3vcOQ32BfhMRu",
    "Kitchen layout": "fldswmspFQ0NB8g00",
    "UW All In Cost (from Property)": "fldeUsjFnH3YMVzTX",
    "Engineering: All in Cost per Unit": "fldoU5pScVthoEF2U",
    "Utility Setup Phone Number (from Owner Entity) (from Property)": "fld51rZdcUTGIumvi",
    "7 bed (from Tract) (from Property)": "fld1rvgK3QsdHh1i9",
    "Vacancy Assumption (from Owner Entity) (from Property)": "fldFVzTRE5UsMC529",
    "Asset Management Fee To Simply (from Owner Entity) (from Property)": "fldFCf90dLC9lfKVO",
    "Phone Number (from Tenant) (from Current Lease)": "fldpcbam3LD3kuIag",
    "Utility Allowance - Suburban Trash (from Utility Configuration)": "fld4fU7FSMathDhcp",
    "Utility Allowance - All Gas Option (from Utility Configuration)": "fldFTFsNmtwtmcGDo",
    "Utility Allowance - Natural Gas Customer Charge (from Utility Configuration)": "fldED21RNCU8Y6rdv",
    "Documents Received  (from External Inspections)": "fldw9K7keEpMDmGdK",
    "Gas Provider": "fldBV91kkZ4D9hxBl",
};
exports.SHu_const_airtable_neighborhoods_fieldIds = {
    Name: "fld2FO5H2IXMaOU0M",
    Market: "fldZ0uDFhKFrfuVXa",
};
exports.SHu_const_airtable_states_fieldIds = {
    Name: "fldMO9UHi1Pq2fvJA",
    "Full Name": "fldHdffMWNOKPHhbZ",
};
exports.SHu_const_airtable_zipcodes_fieldIds = {
    "Zip Code": "fldImD3R5KEJr6kx5",
};
exports.SHu_const_airtable_housingAuthorities_fieldIds = {
    Name: "flddLj2Sy5piMFyGW",
};
exports.SHu_const_airtable_contacts_fieldIds = {
    Type: "fldWGSpPbXYcNOt4c",
    "Transactions 2": "fldn7RcVAnLJuzZV7",
    "Property Managers 2": "fldHJ0lVBvbOpvmW8",
    "Leasing Agencies": "fld581mk2MfSydPn2",
    Lender: "fldrLU4kcKGhMw10Q",
    "Contact Title/Role": "fldjyIkKG45pKqGUq",
    "Property Managers 3": "fldqGe0bJF15Wy2Ol",
    "Simply Share of Commission": "fldA7hWeL9xMYrg6X",
    "Housing Authority": "fldMCtv721NA3I5WS",
    Properties: "flddGw5Kk323ZFm6X",
    "Contact Mobile #": "fldc9BNqxh4M6bk3a",
    "Number of Leads Sourced": "fld5kuT4U3XCmFWAN",
    "Title Companies": "fldKEP2YkIKSyUvkE",
    "Leads 2": "fldmeRFtyYaWHVYNL",
    Company: "fldVBVkvem93FZRLZ",
    "Final HUDs": "fldAIX6Ln4HcR4DAy",
    Name: "fldHhiGuJyLM7Wvju",
    Market: "fldklOv7YW3eTRX1w",
    "Phone Number": "fldEUdqpyJdJHmJ35",
    "Email Address": "fldAPCgz5LhqJb2H1",
    "Record ID": "fldeipikXF1hNWIwP",
    Leads: "fldSfLYTQcl1HQEtE",
    "Insurance Company": "fldAYDDs5rntaHcsg",
    "Property Managers": "fld1zfD85zD1xyFW6",
    Transactions: "fldcRZWOinQjDoeim",
    "Phone Number Standardized": "fldFI8h3kHzrYuZ9h",
};
exports.SHu_const_airtable_leads_fieldIds = {
    "Place ID": "fldi5URkdNqDJUPJ4",
    "Is Buy Box?": "fldz7u2d1WDsif40U",
    "Lead Active Start": "fldFOIoLJdtOajatI",
    "Initial Offer Made Date ": "fldZlpXpeCItU0deI",
    "Lead Active End Date": "fldtX7VoYyav6SAeC",
    "Lead Idle Time": "fldzlDdJeFwe6OCBB",
    "Lead Review Time": "fldsfgEZrlWbmN6Y3",
    "Lead Negotiation Time": "fldzcwriWK1Xjbwxc",
    "Tenant Info Required before Close?": "fldWs1BvwxzEwGwdN",
    "Is in YWCA Opportunity Zone? ": "fldtR45nHUr7PL2zo",
    "Max Offer Vs Asking Price": "fldNh1ZtzmRM99t5P",
    "Last modified status time": "fldGCsFMXFPwmK1mS",
    "Rejection Reason ": "fldw6dfOR1paRAr9X",
    "Regenerate Max Offer Button (from Underwriting)": "fldGeKoI8j5WMV1c1",
    "Max offer Button": "fldQNJd8HnkYsJngd",
    "Lead Next Action to Take ": "fldvxUn2392CebtVs",
    "Inherited Tenant (from Units) (from Properties)": "fldS8TVBzbyuyEUhg",
    "Final HUDs (from Transactions)": "fldnsldZdrJm6nYZu",
    "Borough / Neighborhood (from Properties)": "fldBpgHMzgFkcwWrV",
    "Originators BPO / CMA (from Underwriting)": "fldVyTR0xAOYWbP4W",
    "Originators ARV (from Properties)": "fldGD9ZaHuk6u2jYR",
    "ARV Uplift (from Underwriting) (from Properties)": "fld0GmMeEWhWdrWsE",
    "Number of Units (Calculated) (from Properties)": "fldGGaeVdoNMHQIK0",
    Underwriting: "fldgATuMPpdkotrKi",
    "Zip Code (from Properties)": "fldXgJkNXIL0f77hz",
    "Total Reno Cost (from Inspections)": "fldYJtoFTrVLA7hx6",
    "Created Date": "fldPuCE0LOVhjpq6y",
    Inspections: "fldqRuZmqNPleKfjA",
    "All In Cost (from Underwriting)": "fldAfjMeIt1Ecz5Mw",
    "All In Cost vs Originators ARV": "fldqgoMrktej03G5D",
    "All In Cost vs CoreLogic ARV": "fldNKUvgWv4EaRh47",
    "Manager Note Date": "fldasXk2x61zQNLOB",
    "Title Contact": "fldI2wXMjRVtJqCRx",
    "Price per Square Foot": "fldDgHR0NXbSSGA9n",
    "Square Feet (from Properties)": "fld8J9iomjgO6oPlb",
    "All in Per Square Foot": "fld845HTM1szEDrI7",
    "Simple All In at Asking": "fldrf66GTMDO6gG6d",
    Contingency: "fld8N1G7cHidRqj5V",
    "Reason for Failure (from Inspections)": "fldkO5BASXI8c11Hb",
    "EMD Amount (Leads)": "fldgRv37mS23XQue7",
    "Access Method": "fldvYvwkBzSq6jVyh",
    "Inspection Status (from Inspections)": "fldrFuGU5REcDENpU",
    "Units (from Properties)": "fldNDnc7sqWhU04q8",
    "Buy Side Commission": "fldFZTpwq4dhe58ic",
    "Is Viable?": "fldPA4bBmuXAVrWGB",
    "Title Company": "fldzF8kUnAc4n9o6P",
    Properties: "fldRhehiGVclfk4Ti",
    "Leads Status": "fldrOKrjM4dyC6lHw",
    Assignee: "fldSKkr1bn0tHOKET",
    "Listing Agent": "fldu6nL8pYiVIVtb8",
    "Offer Document": "fldLKtG5jGgiNf4gH",
    "Marketing Links": "flddqcnrXOVj3jjEM",
    "Internal General Contractor (from Market) (from Properties)": "fldPxlVH8nmmjJKby",
    "Record ID": "fldcDhdUrNDuBLyX0",
    "Agent Phone Number": "fldqP6Foawi2ceX9I",
    Transactions: "fldz8CaU4HaPmwzvY",
    "AC Status (from Underwriting)": "fldufdIzU0IkmV1p4",
    Name: "fldSxrGleBgQM63fK",
    "Asking Price": "fldYuWmT1DKnPsjHM",
    Market: "fld7OZAIblj689vNn",
    "Vacancy (On Delivery per Contract)": "fldq5YgEO0xdo8y8X",
    "Contract Date (Leads)": "fldmLKx76hOK3tKRS",
    Source: "fldiLJF18g0xxYDUU",
    "Latest Offer vs Max Offer": "fldaaFHXMlK7ZLAd5",
    "Email Address (from Contracting Agent / Seller)": "fldM2iXnkwAWMMU64",
    "Max Offer Amount": "fldi81ZJVkAM0RW93",
    "Latest Offer Amount": "fldVwz30LxNAMW0Pc",
    "Approved Offer": "fldwoks2HWlboOgHm",
    "In Market Acquisition Manager Notes": "fldTcA1ivlfr73Dbw",
    "Suggested Offer Price": "fldUW6QbTSdvDVST3",
    "Transaction Status (from Transactions)": "fldzVTsfOB8FcAMl4",
    "Purchase and Sale Agreement": "fldg2VcR0TsV3OwUY",
    "NOI Cap Rate (from Underwriting)": "fldgpdEEFc2hzL3a3",
    "Corelogic ARV": "fldbCwVZofg7LxuEp",
    "Originators Renovation Estimate": "flduoEcW6fFMDbii8",
    "Contract Price (Leads)": "fldymK4sp9yQChDrs",
    "Date of End of Inspection Period (Leads)": "flde3hyS6mh5mdwfj",
    "Contract Closing Date (Leads)": "fldY9eVfxhm0RF3zJ",
    "Simply Acquisition Fee (from Underwriting)": "fld2gSAYvTpqnfrTW",
    "One Line Address (from Properties)": "fldKZAiIdjRDPihfd",
    "Primary Email (from Title Company)": "fldcv08QIhbn3xFSl",
    "Other Documents": "fldiIWlyF4mSq2BTx",
    "Originator Note Date": "fld0lwtqlAsHYkCQV",
    "Third Party Assignment Agreements": "fldyzZLsYTOcMN5b5",
    "Third Party Assignment Fee": "fldvjtLEEbWTf3kaE",
    "Estimated Closing Date (from Transactions)": "flds9qUUcPGnRho3x",
    Walkthroughs: "fldnAQDXEyvSpw8XU",
    "Originator Override ARV": "fldc1jGx8xAayXIBS",
    "BPO / CMA Report": "fldXsRj43w0XWDmSE",
    "Wholeseller Deal  Status": "fldqmSmNhVOhoWB3d",
    "Buy Side Commission Override": "fld2Gpw7Es79O2hDq",
    "Selling Agent": "fldCBURoWJNGVMgey",
    "Initial SOW (from Inspections)": "fldl4MTXZIWSYRdKf",
    "Bedrooms (from Units) (from Properties)": "fld7p4Lzfuv0q2SaB",
    "Total Bedrooms (from Properties)": "fldTzNOwu6J0Be9DC",
    "Street Address": "fldxgpRLchQbFfMRp",
    "Agreed Price": "fldbxPNOtqI8LbsBQ",
    "Acquisition Supervisor Notes": "fldWfRWPcqHfv9jl3",
    "MLS Link": "fldTXG1TZckEY05lW",
};
exports.SHu_const_airtable_UtilityAllowanceConfiguration_fieldIds = {
    Name: "fldY922xpW8LRmxMR",
    "Utilities Sheets": "fld3wvsa9QipDHNTv",
    "Utility Allowance - Heating Natural Gas": "fld18vZsSGNQK9W4y",
    "Utility Allowance - Heating Oil": "fldieccQyLRzRahHu",
    "Utility Allowance - Cooking Natural Gas": "fldYJHlfbeZkmiv0E",
    "Utility Allowance - Cooking Bottled Gas": "fldW21162z2DxgVWB",
    "Utility Allowance - Cooking Electric": "fldALGQCxlcwgr8GD",
    "Utility Allowance - Water Heat Natural Gas": "fld7dQZLpDb1hfYA1",
    "Utility Allowance - Water Heat Oil": "fldtWKmitTEkt0dZn",
    "Utility Allowance - Other Electric": "fldqLZDeDL8JNDXNn",
    "Utility Allowance - Water": "fldMjbGaqFKr4IfrI",
    "Utility Allowance - Sewage": "fldAF1Y3gQ7HaYYeB",
    "Utility Allowance - Trash": "flddeaixZLOQTzsWl",
    "Utility Allowance - Refrigerator": "fldxLyb2XEdZ2fppI",
    "Utility Allowance - Range": "fldCV1yvaQpiGybFe",
    "Utility Allowance - Microwave": "fldBkE3SPosnlfA9l",
    "Utility Allowance - Natural Gas Customer Charge": "fldzmNdxOM1HdTFm1",
    "Utility Allowance - All Gas Option": "fld0rUziOhXF1v8JM",
    "Utility Allowance - Electricity Customer Charge": "fldYlnfDMxFihIaOk",
    "Utility Allowance - City Trash": "fldT7CnbitoXu2bX3",
    "Housing Authority": "fldCMfS443KZUe1lc",
    "Reference Name (from Housing Authority)": "fld9aDQT902LnVl9h",
    "Utility Allowance - Water/Sewage (Suburban)": "fldfUjbvR9ASjrrRs",
    "Utility Allowance - Water/Sewage (City)": "fldfVB2Zg478Qpd4c",
    "Utility Allowance - Water/Sewage (City2)": "fldMubVzkfV4oZeOK",
    "Utility Allowance - Trash (City)": "fldtWooPf1T5O3fy8",
    "Utility Allowance - Trash (Suburban)": "fldimP2z6KlNxoybV",
    "Unit Count TEMP": "fld4ZojytLC8mAURV",
    "Bed Count Configuration": "fldG68WBlI1nXPhFL",
    "Utility Allowance - Water Heat Bottled Gas": "fldMrxBbfJFKrpv6e",
    "Utility Allowance - Suburban Trash": "fldaBCI28ct0QVDcH",
    "House Type": "fldo4afqttkibOc2V",
    Units: "fldd4C9F3vKXI0Nuj",
    "Utility Allowance - All Gas Option (Heat and Cooking)": "fldjNlInurd7Lm4sj",
    "Utility Allowance - All Gas Option (Water Heat)": "fldnjnQfyZKkDBU1z",
    "Utility Allowance - Heating Bottled Gas": "fldQGhpgdaYby29uv",
    "Utility Allowance - Heating Electric": "fldhQwYNYXbhyfUu9",
    "Utility Allowance - Heating Electric (Heat Pump)": "fld8KfJTe0cTMreup",
    "Utility Allowance - Air Conditioning": "fldh8ozy3eEoBSSBg",
    Year: "fldWPKVFq9cmoKfPY",
    "Utility Allowance - Water Heat Electric": "fldDIk2M7wo4ZBNcQ",
};
exports.SHu_const_airtable_DailyUnitsStatusReporting_fieldIds = {
    "Total Showings": "fld2AmoAURAcdf9o0",
    "Total Applications": "fldkaqyEfJmztL4ic",
    "Units Prepared": "fldEYVGmg2WDwaBOe",
    "Number Of Units Tenant Selected": "fldfokSnRtyqFBW40",
    "Properties Owned": "fldRZLLLwOTamoL8M",
    "Week Of the Year": "fld0GbyuUr8SW0s4N",
    "Units Tenant Selected": "fldZdOXQnuwQvnUHg",
    "Number Of Showings": "fldVkbtf6BDs3kbbk",
    "Number Of Units In Renovation": "fldiDUTlJOu5eTtcL",
    "Number Of Applications": "fldhQ36NETfMCqSUT",
    "Number Of Units Owned": "fldrt1pzIAuLRctbo",
    "Number Of properties Owned": "fldaiSKT93o2OsnAC",
    "Properties Contracted": "fldkRtdahGEvJNNG3",
    "Number Of Units Listed": "fld7gxvyWNkkuC6wX",
    "Units Listed": "fldCHwwf68STC21vj",
    "Units Leased": "fldeXHlKVMIgcQSOf",
    "Date Created": "fldpS1SBsw1VteFdP",
    "Number Of Properties Contracted": "fldBuOhflXbqsapJ2",
    "Number Of Units Prepared": "fldg3XWHff3Y1fvnJ",
    "Units In Renovations": "fldgkRk6R96Z4DFJT",
    "Units Owned": "fldXjtkdkz1XFLBz8",
    "Number Of Units Occupied": "fldxRhRGnlI6h87VK",
    "Units Occupied": "fldKN040Lttz7fxlf",
    "Number Of Units Leased": "fldYTqx3l8nEt96Iw"
};
exports.SHu_const_airtable_rentalListing_fieldIds = {
    "Daily Properties/Units Status Reporting": "fldOTXk17w9GjOiC1",
    "Current Lease (from Units)": "fldpGygVAmZpTnD82",
    "Renovations": "fld0ZYcAvp9lATCcV",
    "Listing Reports": "fldJ0D66SZ1wkTcYI",
    "Unit Access (from Units)": "fldaG1k3XGPE3F3dW",
    "PM Leasing Access": "fldRKOUqKkAoJOJnr",
    "Electricity Status": "fldetyEs6qacJdIPI",
    "Estimated Monthly HCV Utility Deduction (from Units)": "fldb4AHYXW6K9Bi6X",
    "Estimated Monthly Gross Rent (from Units)": "fldNaSmUq8SvHJu5t",
    "Zillow Listing URL": "fldpLRHXjSNFrmT0i",
    "PM Walkthrough Report": "fldn9AD5I3ooJFkJs",
    "Property Manager (from Property) (from Units)": "fldI98ZQEux8jmyw8",
    "Listing Status": "fldJYEg4OecAmlAKZ",
    "Estimated Monthly HCV Rent (from Units)": "fldTn34Zn7ETb9w7z",
    "Name": "fldpcsbMeTLubmvq6",
    "Units": "fldGVqo7WjpVt0PJP",
    "Operating Status (from Units)": "fldjJcbQkN1FY2TiM",
    "RentoMeter Market Rent (from Units)": "fld15SUSmvGUQH43U",
    "Renovation Status (from Renovations) (from Units)": "fldLo949o1Gl3vizs",
    "Market (from Property) (from Units)": "fldlRNcmm0mcsBrPZ",
    "Tenancy Status (from Units)": "fldq5p9la1DQu1aS8",
    "Unit Name (from Units)": "fldFTWcQThIfzYLHC",
    "AffordableHousing.com Listing URL": "fldNruCu6TU0kZX6N",
    "Date of First Showing": "fldTq6sPg8Y0DCpYP",
    "External Inspections": "fldeI93rXC09P8Uus",
    "Housing Authority (from Property) (from Units)": "fldhVX5mvWznqMbgN",
    "Bedrooms (from Units)": "flduGWyIKaxZ3VmgE",
    "Bathrooms (from Units)": "fldgrzfdC1CDFnilU",
    "Assignee": "fldzVASKpFWmiDKs4",
    "Creation Date": "fldWfPg6SRFpimBBJ",
    "Time from Creation to PM Walkthrough": "fldhAEIIi9pAU2Tja",
    "PM Walkthrough Date": "fld94bbqCO18XtuwO",
    "PM Punch list": "fldQqBZZfHBUeEDRh",
    "Time Between PM Walkthrough Date and Prepare for Market Date": "fldM0pandcEwjWGSR",
    "Prepare for Market Date": "fldLynPViAqY93W7A",
    "Time Between Prepare for Market and Listing Published": "fld31dSPXe0xUM92n",
    "Listing Publish Date": "fldOm8yeniMJXWyY8",
    "Listing Process Notes": "fld6iTMIvW2Y3QSOZ",
    "Number Of Inspections(section 8)": "fld4BdtWQTNJUHUMa",
    "RFTA Approval Date": "flddlgrK3F7nPxrxY",
    "Date of First Application": "fld8TPauWdWZbMetm",
    "Total Showings": "fldHYdhTTflb6ULR2",
    "Total Applicants": "fldfX4EMXXvJXonP5",
    "Time Between Listing Published and Tenant Selected": "fldxRbmMekZYVSLum",
    "Tenant Selected Date": "fldRUoGt2vC3hFCIH",
    "Time Between Tenant Selected and RFTA submission": "fldLcupLQRJY0qFll",
    "RFTA Submission Date": "fldBv0Ehez8QgCmeL",
    "Time Between RFTA Submission and First Inspection scheduled": "fldOspD9InuWbj5gd",
    "Section 8 Inspection Date(First)": "fldGcC4DZlBnxk7QR",
    "Time Between First inspection and inspection passed": "fldbo4EIMFQghDXmT",
    "Time between Section 8 Passed Date to RFTA Approval": "fldzKXwNR9VRguLne",
    "Lease Signed Date": "fldUTYBwOTK7kyP1H",
    "Time Between RFTA Approval Date and PM Lease Signed": "fldThTg43HSPp2TOm",
    "Estimated Renovation Completion Date (from Renovations) (from Units)": "fldEfxRp7N7Gr9KU2",
    "RAG formula": "fldjXpm5dVOuamDlM",
    "Prospect Comments": "fldhVUWovAq5d40l9",
    "Record ID": "fldGxZNd9wbOyKdTt",
    "Applicant Notes": "fldTLm4GsUINoiJqR",
    "Leasing Notification Contacts (from Property Managers) (from Property) (from Units)": "fldRKeqfMS9yV4Kpc",
    "Punch List (from Renovations)": "fldsfwMxBBgeWsG4D",
    "Gas": "fldYbMUTXdSOirWv0",
    "Account Type (from Utility Accounts) (from Units)": "fld6uNUjAV14Jl7fE",
    "Utility Status (from Utility Accounts) (from Units)": "fldoKJMK18W4eseO5",
    "Utility Accounts (from Units)": "fldAPtJe7hgB5XIxX",
    "Additional Listing URLs": "fldza5a90Sfa04OQt",
    "Section 8 Inspection Passed Date": "fldXvdtmy15GPmlVt",
    "Lease": "fldw5lm9dbo8rHV2q"
};
